
export const th = {

    'version': '1.167',

    // header
    'menu1': 'หน้าหลัก',
    'menu2': 'กองทุนรวม',
    'menu3': 'กองทุนส่วนบุคคล',
    'menu4': 'กองทุนสำรองเลี้ยงชีพ',
    'menu5': 'วางแผนการลงทุน',
    'menu6': 'ช่องทางบริการผู้ถือหน่วยลงทุน',
    'menu7': 'เกี่ยวกับเรา',
    'menu8': 'ติดต่อเรา',
    'oneLive': 'One Live บริการซื้อขายออนไลน์',
    'search': 'พิมพ์คำที่ต้องการค้นหา',
    'searchonly': 'ค้นหา',
    'text_close': 'ปิด',

    // footer
    'fmenu1': 'หน้าหลัก',
    'fmenu2': 'การกำกับดูแลกิจการ',
    'fmenu3': 'กองทุนรวม',
    'fmenu4': 'การกำกับดูแลธุรกิจการลงทุน',
    'fmenu5': 'วางแผนการลงทุน',
    'fmenu6': 'ช่องทางบริการผู้ถือหน่วยลงทุน',
    'fmenu7': 'กองทุนส่วนบุคคล',
    'fmenu8': 'ข่าวสารและประกาศ',
    'fmenu9': 'กองทุนสำรองเลี้ยงชีพ',
    'fmenu10': 'โปรโมชั่นและสิทธิประโยชน์',
    'fmenu11': 'ปฏิทินวันหยุดกองทุน',
    'fmenu12': 'คำถามที่พบบ่อย',
    'fmenu13': 'แผนผังเว็บไซต์',
    'fmenu14': 'สมัครงาน',
    'fmenu15': 'ติดต่อเรา',
    'fmenu16': 'ประกาศความเป็นส่วนตัว',
    'fmenu17': 'ประกาศความเป็นส่วนตัวของพนักงานและบุคลากรของบริษัท',
    'ftitle': 'ผู้ลงทุนควรทำความเข้าใจลักษณะสินค้า เงื่อนไขผลตอบแทน และความเสี่ยงก่อนตัดสินใจลงทุน',
    'back': 'กลับสู่หน้าหลัก',
    'back2': 'กลับ',
    'backpro': 'กลับสู่หน้าโปรโมชั่นและสิทธิประโยชน์',
    'backcal': 'กลับสู่หน้าวางแผนการลงทุน',
    'backfundcom': 'กลับสู่หน้าเปรียบเทียบกองทุน',
    'backfundrecom': 'กลับสู่หน้ากองทุนแนะนำ',
    'backfundmarket': 'กลับสู่หน้าสรุปภาวะตลาด',

    // main-page #1
    // sub-4menu
    'sub4menu1': 'วางแผนการลงทุน',
    'sub4menu2': 'สรุปภาวะตลาดและสถานการณ์ลงทุน',
    'sub4menu3': 'โปรโมชั่น และสิทธิประโยชน์สำหรับคุณ',
    'sub4menu4': 'ดาวน์โหลดแบบฟอร์ม',

    // 2box
    'twoboxtitle1': 'เครื่องคำนวณการลงทุน',
    'twoboxtitle2': 'ผลการดำเนินงานกองทุน',
    'twoboxdetail1': 'เครื่องมือคํานวณ ที่จะช่วยให้คุณคํานวณเงินอย่างง่ายดาย รวดเร็ว และสะดวกสบายผลการดําเนินงานกองทุน',
    'twoboxdetail2': 'ตรวจสอบผลการดำเนินงาน Fund Performance ของกองทุนได้ที่นี่',

    // defaultTitle-select1
    'defaulttitle1': 'เลือกกองทุน',
    'defaulttitle2': 'วันที่ลงทุน',
    'defaulttitledate1': 'วันที่ลงทุน',
    'defaulttitledate2': 'ข้อมูล ณ วันที่',
    'defaulttitlebtn': 'คำนวณผลลัพธ์',

    // defaultTitle-select2
    'menutitlebar0': 'กองทุนแนะนำ',
    'menutitlebar1': 'ทรัสต์เพื่อการลงทุนในอสังหาริมทรัพย์',
    'menutitlebar2': 'กองทุนรวมตลาดเงิน',
    'menutitlebar3': 'กองทุนรวมตราสารทุน',
    'menutitlebar4': 'กองทุนรวมตราสารหนี้',
    'menutitlebar5': 'กองทุนรวมตราสารหนี้แบบกำหนดระยะเวลาลงทุน',
    'menutitlebar6': 'กองทุนรวมผสม',
    'menutitlebar7': 'กองทุนรวมตราสารทุนที่ลงทุนในต่างประเทศ',
    'menutitlebar8': 'กองทุนรวมตราสารหนี้ที่ลงทุนในต่างประเทศ',
    'menutitlebar9': 'กองทุนรวมผสมที่ลงทุนในต่างประเทศ',
    'menutitlebar10': 'กองทุนที่จดทะเบียนซื้อขายในตลาดหลักทรัพย์ (ETF)',
    'menutitlebar11': 'กองทุนรวมหุ้นระยะยาว (LTF)',
    'menutitlebar12': 'กองทุนรวมเพื่อการเลี้ยงชีพ (RMF)',
    'menutitlebar13': 'กองทุนรวมกลุ่มอุตสาหกรรม',
    'menutitlebar14': 'กองทุนรวมทรัพย์สินทางเลือก',
    'menutitlebar15': 'กองทุนรวมที่มีทุนมาจากต่างประเทศ',
    'menutitlebar16': 'กองทุนรวมอสังหาริมทรัพย์',
    'menutitlebar17': 'กองทุนรวมเพื่อการออม (SSF)',
    'menutitlebar18': 'กองทุนไทยเพื่อความยั่งยืน',
    'menutitlebar19': 'กองทุนรวมอื่นๆ',

    // box3
    'titlebox3': 'มูลค่าหน่วยลงทุนกองทุน',
    'searchtitle3': 'ค้นหามูลค่าหน่วยลงทุนกองทุน',
    'subtitlebox3': 'เลือกกองทุนตามประเภท',

    // box4
    'titlebox4': 'ติดตามมูลค่าหน่วยลงทุนกองทุนง่ายๆ แค่กด',
    'labelpsbox4': 'กองทุนแนะนํา',

    // box5
    'titlebox5': 'ไม่รู้ว่าจะเลือกกองทุนไหนดี?',
    'detailbox5': 'เราแนะนํากองทุนที่ดีที่สุดให้กับคุณ',
    'menu1box5': 'กองทุนผลการดำเนินงานโดดเด่น',
    'menu2box5': 'กองทุนแนะนำ',
    'menu3box5': 'จัดพอร์ตการลงทุน',
    'btnbox5': 'ดูกองทุนทั้งหมด',
    'menu2box5ex': 'กองทุนแนะนำ (วัดจากอัตราผลตอบแทนดีเยี่ยม)',

    // box6
    'menu1box6': 'ข่าวสาร >',
    'menu2box6': 'กองทุนแนะนำ >',
    'menu3box6': 'ประกาศ >',
    'menu4box6': 'โปรโมชั่น >',
    'menu5box6': 'Earth Update >',

    // fund-card
    'fundcardtitle1': 'มูลค่าหน่วยลงทุน',
    'fundcardtitle2': 'ราคาขาย',
    'fundcardtitle3': 'ราคารับซื้อคืน',
    'fundcardtitle4': 'มูลค่าทรัพย์สินสุทธิ',
    'fundcardtitle5': 'ณ. วันที่',
    'fundcardtitle6': 'มูลค่าทรัพย์สินรวม',

    // กองทุนรวม #2
    'p2title': 'ไม่รู้จะเลือกกองทุนไหน? มาเลือกกองทุนรวมง่ายๆ กับ 3 จุดประสงค์หลักการลงทุน',
    'p2titlelbox': 'เลือกจากเป้าหมายที่ต้องการ',
    'p2titlerbox': 'จัดพอร์ตการลงทุนตามระดับความเสี่ยงที่ยอมรับได้',
    'p2titlecbox': 'เลือกกองทุนตามประเภท',
    // Lbox
    'p2titlelboxmenu1': 'มือใหม่หัดลงทุน',
    'p2titlelboxmenu2': 'เพื่อเป้าหมาย',
    'p2titlelboxmenu3': 'เพื่อเกษียณ',
    // Rbox
    'p2titlerboxmenu1': 'ความเสี่ยงต่ำ',
    'p2titlerboxmenu2': 'ความเสี่ยงปานกลาง',
    'p2titlerboxmenu3': 'ความเสี่ยงสูง',
    // Cbox
    'menudetailbar1': '',
    'menudetailbar2': 'กองทุนที่เรานำเงินไปลงทุนในตราสารหนี้ที่มีความมั่นคง มีสภาพคล่องสูง เช่น เงินฝาก ตราสารหนี้ภาครัฐ ตราสารหนี้สถาบันการเงิน กองทุนรวมตลาดเงินเหมาะสำหรับผู้ลงทุนที่ต้องการลงทุนในระยะสั้น และยอมรับความเสี่ยงจากการลงทุนที่ได้รับผลตอบแทนต่ำ',
    'menudetailbar3': 'กองทุนรวมที่เน้นลงทุนในหุ้นจดทะเบียนที่มีปัจจัยพื้นฐานดี และมีแนวโน้มการเติบโตสูง มีโอกาสได้รับผลตอบแทนสูง เหมาะสำหรับผู้ลงทุนที่ต้องการผลตอบแทนในระดับสูง และยอมรับความเสี่ยงจากการปรับตัวผันผวนของกองทุนได้',
    'menudetailbar4': 'กองทุนตราสารหนี้ เป็นการลงทุนในตราสารหนี้ เช่น พันธบัตรรัฐบาล ตั๋วสัญญาใช้เงิน ตั๋วแลกเงิน หุ้นกู้ และเงินฝากธนาคาร เหมาะสำหรับผู้ลงทุนที่รับความเสี่ยงได้ต่ำ โดยผู้ลงทุนสามารถเลือกรูปแบบของกองทุนตราสารหนี้ที่เหมาะสมกับตนเอง',
    'menudetailbar5': 'กองทุนรวมตราสารหนี้แบบกำหนดระยะเวลาลงทุน',
    'menudetailbar6': 'กองทุนผสม (Mixed Fund) คือ กองทุนที่กระจายการลงทุนในหลักทรัพย์หลายประเภท เช่น ตราสารหนี้ ตราสารทุน ตราสารอนุพันธ์ ในสัดส่วนการลงทุนที่เหมาะสม (Asset Allocation) กับภาวะการลงทุนในแต่ละช่วง หรืออยู่ในกรอบที่นโยบายการลงทุนกำหนด โดยมีรูปแบบการลงทุนที่หลากหลาย',
    'menudetailbar7': 'กองทุนรวมที่เน้นลงทุนในหุ้นจดทะเบียนที่มีปัจจัยพื้นฐานดี และมีแนวโน้มการเติบโตสูง มีโอกาสได้รับผลตอบแทนสูง เหมาะสำหรับผู้ลงทุนที่ต้องการผลตอบแทนในระดับสูง และยอมรับความเสี่ยงจากการปรับตัวผันผวนของกองทุนได้',
    'menudetailbar8': 'ช่องทางการกระจายการลงทุนในสินทรัพย์ต่างประเทศ มีนโยบายการลงทุนหลากหลาย',
    'menudetailbar9': 'กองทุนที่กระจายการลงทุนในหลักทรัพย์หลายประเภท เช่น ตราสารหนี้ ตราสารทุน ตราสารอนุพันธ์ ในสัดส่วนการลงทุนที่เหมาะสม (Asset Allocation) กับภาวะการลงทุนในแต่ละช่วง หรืออยู่ในกรอบที่นโยบายการลงทุนกำหนด โดยมีรูปแบบการลงทุนที่หลากหลาย',
    'menudetailbar10': 'กองทุนเปิดที่จดทะเบียนในตลาดหลักทรัพย์ มีนโยบายการลงทุน มุ่งเน้นให้ได้ผลตอบแทนที่ใกล้เคียง หรือเทียบเท่ากับดัชนีที่ใช้อ้างอิง (underlying index) เช่น ดัชนีหลักทรัพย์ ราคาทองคำ เป็นต้น ผู้ลงทุนสามารถซื้อขายเหมือนการซื้อขายหุ้นในตลาดหลักทรัพย์ 1. กองทุนเปิดไทยเด็กซ์เซ็ท 50 อีทีเอฟ (TDEX) มุ่งสร้างผลตอบแทนให้ใกล้เคียงกับดัชนี SET50 Index 2. กองทุนเปิดไทยเด็กซ์เซ็ท 100 อีทีเอฟ (TH100) มุ่งสร้างผลตอบแทนให้ใกล้เคียงกับดัชนี SET100 Index 3. กองทุนเปิดไทยเด็กซ์ SET High Dividend ETF (1DIV) ลงทุนในหลักทรัพย์ที่เป็นส่วนประกอบของดัชนี SET High Dividend 30 Index เพื่อสร้างผลตอบแทนใกล้เคียงกับดัขนี 4. กองทุนเปิด วรรณ STOXX อาเซียน ซีเล็ค ดิวิเดนด์ อินเด็กซ์ ฟันด์ (ONE-STOXXASEAN) มุ่งสร้างผลตอบแทนที่ดีให้ใกล้เคียงกับดัชนี STOXX ASEAN SELECT DIVIDEND 30 INDEX โดยกองทุนอยู่ภายใต้โครงการ ASEAN CIS และจะปฏิบัติตามเกณฑ์ที่กำหนดใน Standards of Qualifying CIS ของ Memorandum of Understanding on Streamlined Authorisation Framework for Cross-border Public Offers of ASEAN Collective Investment Schemes',
    'menudetailbar11': 'เหมาะสำหรับผู้ลงทุนที่หวังผลในระยะยาว กับการลงทุนที่มีแต้มต่อ จากสิทธิประโยชน์ทางภาษี ประหยัดภาษี 2 ต่อ ทั้งลดหย่อนเงินได้พึงประเมิน และยกเว้นภาษีเงินได้จากการลงทุน',
    'menudetailbar12': 'กองทุนที่ผู้มีรายได้สามารถเลือกลงทุนเพื่อสะสมเงินไว้ใช้หลังวัยเกษียณ และได้รับสิทธิประโยชน์การลดหย่อนทางภาษีจากรัฐเป็นแรงจูงใจ เหมาะสำหรับผู้ลงทุนที่ต้องการวางแผนการเงิน เพื่อความมั่นคงของชีวิตในวัยเกษียณ',
    'menudetailbar13': 'กองทุนรวมประเภทที่เน้นลงทุนในกลุ่มอุตสาหกรรมใดอุตสาหกรรมหนึ่งเป็นหลัก เช่น กลุ่มธุรกิจอสังหาริมทรัพย์ ทำให้การลงทุนมีความกระจุกตัวค่อนข้างสูง เหมาะสำหรับผู้ลงทุนที่สามารถรับความเสี่ยงได้สูง',
    'menudetailbar14': 'กองทุนรวมทรัพย์สินทางเลือก',
    'menudetailbar15': 'กองทุนรวมที่มีทุนมาจากต่างประเทศ Country Fund',
    'menudetailbar16': 'กองทุนรวมที่นำเงินที่ได้จากการจำหน่ายหน่วยลงทุน ไปซื้อหรือเช่าอสังหาริมทรัพย์ และจัดหาผลประโยชน์จากอสังหาริมทรัพย์นั้นโดยการนำไปให้เช่าอสังหาริมทรัพย์ที่ลงทุน อาจจะเป็นสำนักงาน ที่พักอาศัย ศูนย์การค้า โรงแรม โรงงาน โกดังเก็บสินค้า ฯลฯ โดยจะมีการระบุไว้ในนโยบายการลงทุนของแต่ละกองทุน โดยเสนอขายหน่วยลงทุนในช่วงแรกให้กับประชาชนและผู้ลงทุนทั่วไป (Public Offering) และจะนำหน่วยลงทุนไปจดทะเบียนในตลาดหลักทรัพย์แห่งประเทศไทย เพื่อเพิ่มสภาพคล่องให้แก่ผู้ลงทุน เหมาะกับผู้ลงทุนที่ไม่สามารถใช้เงินลงทุนจำนวนมากไปลงทุนในอสังหาริมทรัพย์เพื่อเก็บค่าเช่าได้ด้วยตัวเอง ให้สามารถลงทุนด้วยเงินจำนวนน้อยกว่า เพื่อเก็บรายได้ค่าเช่าแล้วคืนให้กับผู้ถือหน่วยในรูปของเงินปันผล',
    'menudetailbar17': 'กองทุนรวมที่มีวัตถุประสงค์ในการส่งเสริมการออมระยะยาวของผู้ลงทุน และหมายความรวมถึงกองทุนรวมที่มีการแบ่งชนิดของหน่วยลงทุนตามกรณีสิทธิประโยชน์ทางภาษี  ซึ่งผู้ถือหน่วยลงทุนจะได้รับสิทธิประโยชน์ทางภาษีเมื่อผู้ลงทุนซื้อหน่วยลงทุน และปฏิบัติตามหลักเกณฑ์ วิธีการ และเงื่อนไข ตามที่กรมสรรพากร และ/หรือ กฎหมายอื่นใดที่เกี่ยวข้องกำหนด',

    // fund-list-component
    'fundlisttitle1': 'กองทุน บลจ. วรรณ',
    'fundlisttitle2': 'ความเสี่ยง',
    'fundtitlerisk': 'พอร์ตการลงทุนเพื่อชนะเงินเฟ้อ',

    // fund-risk-component
    'fundriskdetailtitle1': 'อัตราผลตอบแทนที่คาดหวังต่อปี',
    'fundriskdetailtitle2': 'โอกาสที่จะชนะเงินเฟ้อใน 1 ปี',
    'fundriskdetailtitle3': 'ความเสี่ยงของพอร์ตการลงทุนนี้',
    'fundriskdetailtitle4': 'กองทุนตลาดเงิน',
    'fundriskdetailtitle5': 'กองทุนตราสารหนี้',
    'fundriskdetailtitle6': 'กองทุนผสม',
    'fundriskdetailtitle7': 'กองทุนตราสารทุน',
    'fundriskdetailtitle8': 'กองทุนทางเลือก',

    // Graph title
    'graphtitle1': 'กองทุนตลาดเงิน',
    'graphtitle2': 'กองทุนตราสารหนี้',
    'graphtitle3': 'กองทุนผสม',
    'graphtitle4': 'กองทุนตราสารทุน',
    'graphtitle5': 'กองทุนทางเลือก',

    // Assumption
    'assumptiontitle': 'เพื่อคำนวณประมาณผลตอบแทน ณ วันที่ 30/11/2016',
    'assumptiondetail1': 'อัตราดอกเบี้ยนโยบาย 1 ปีข้างหน้า อยู่ ณ ระดับ 1.625%',
    'assumptiondetail2': 'SET Index 1 ปีข้างหน้าเคลื่อนไหวในกรอบ 1,520 - 1,850 จุด โดยมีกรณีฐานที่ 1,640 จุด',
    'assumptiondetail3': 'FED ปรับขึ้นอัตราดอกเบี้ยนโยบาย 1 ปีข้างหน้าจำนวน 2 ครั้งเป็น 1.00 - 1.25%',
    'assumptiondetail4': 'เศรษฐกิจโลกปรับตัวดีขึ้น โดยเฉพาะสหรัฐอเมริกา ขณะที่จีนยังไม่ได้รับผลกระทบจากนโยบายกีดกันทางการค้ามากนักและสหภาพยุโรปยังไม่ได้รับผลกระทบจากความเสี่ยงด้านการเมือง',
    'assumptiondetail5': 'หมายเหตุ ค่า Var 95% แสดงถึงโอกาสที่ผลตอบแทนของกองทุนจะติดลบสูงสุดที่ความเชื่อมั่น 95%',
    'assumptiondetail6': 'พอร์ตการลงทุนที่แนะนำตามระดับความเสี่ยงข้างต้น เป็นแนวทางการจัดพอร์ตการลงทุนโดยทั่วไปเท่านั้น และไม่ได้เป็นการรับประกันผลตอบแทนจากการจัดพอร์ตการลงทุน ซึ่งผลตอบแทนดังกล่าวสามารถเปลี่ยนแปลงตามสภาวะตลาด ทั้งนี้ ผู้ลงทุนควรได้รับคำแนะนำการลงทุนเป็นรายบุคคลและควรศึกษาข้อมูลกองทุนก่อนการตัดสินใจลงทุน',

    // กองทุนส่วนบุคคล app-private-fund
    'privatetitile1': 'กองทุนส่วนบุคคล คือ',
    'privatdetail1': 'บุคคล คณะบุคคล หรือนิติบุคคลใดๆ ที่มีวัตถุประสงค์ต้องการลงทุนในหลักทรัพย์ประเภทต่างๆ โดยมอบหมายให้บริษัทจัดการหรือสถาบันการเงินที่ได้รับใบอนุญาตจัดการกองทุนส่วนบุคคลเป็นผู้บริหารเงินลงทุนนั้น ทั้งนี้ จะมีการทำความเข้าใจร่วมกันระหว่างบริษัทจัดการและผู้ลงทุนถึงนโยบายการลงทุน โดยจัดทำเป็นหนังสือสัญญาข้อตกลงระหว่างบริษัทจัดการกับผู้ลงทุนเฉพาะแต่ละรายก่อนที่จะรับเงินลงทุนหรือทรัพย์สินต่างๆ มาบริหาร',
    'privatdetail2': 'ทั้งนี้บริษัทจัดการ จะขอข้อมูลของลูกค้าเกี่ยวกับฐานะทางการเงิน ภาระทางการเงิน ระยะเวลาในการลงทุน ประสบการณ์ในการลงทุน ระดับความเสี่ยงที่ยอมรับได้และผลตอบแทนที่คาดหวัง เพื่อทำความรู้จักสถานะของลูกค้า (know your customer) และนำข้อมูลที่ได้มาวิเคราะห์เพื่อกำหนดนโยบายการลงทุนให้เหมาะสมกับลูกค้า (suitability) โดยการลงทุนจะอยู่ภายใต้การกำกับและดูแลของคณะกรรมการกำกับหลักทรัพย์และตลาดหลักทรัพย์ (ก.ล.ต.)',
    'privattitle1sub1': 'จุดเด่นของกองทุนส่วนบุคคล',
    'privattitle1sub1menu1line1': 'สร้างการลงทุน',
    'privattitle1sub1menu1line2': 'ตามความเสี่ยงที่ยอมรับได้',
    'privattitle1sub1menu2line1': 'มีความคล่องตัวสูง',
    'privattitle1sub1menu2line2': 'ปรับเปลี่ยนนโยบายการลงทุนได้',
    'privattitle1sub1menu3line1': 'บริหารโดยมืออาชีพ',
    'privattitle1sub1menu3line2': 'ที่มีประสบการณ์',

    'privattitle1sub2': 'สิทธิประโยชน์ที่ได้รับ',
    'privattitle1sub2detailline1': 'เงินลงทุนสามารถกระจายความเสี่ยงได้มากกว่าการลงทุนโดยตรง',
    'privattitle1sub2detailline2': 'บริษัทจัดการจะหาโอกาสการลงทุนในตราสารใหม่ๆ ที่ให้ผลตอบแทนสูงอยู่เสมอ',
    'privattitle1sub2detailline3': 'มีอำนาจต่อรองที่มากขึ้นจากการบริหารเงินกองทุนรวมกัน',
    'privattitle1sub2detailline4': 'ลดภาระการติดต่อสถาบันการเงิน การติดตามข่าวสาร และการบริหารเงินด้วยตนเอง',

    'privatetitile2': 'การบริการกองทุนส่วนบุคคลของ บลจ. วรรณ',
    'privatetitile2sub1': 'รายสัปดาห์',
    'privatetitile2sub2': 'รายเดือน',
    'privatetitile2sub3': 'รายปี',

    'privatetitile2sub1list1': 'รายงานสถานะการลงทุน',

    'privatetitile2sub2list1': 'รายงานสถานะการลงทุน และผลประกอบการของกองทุน',
    'privatetitile2sub2list2': 'รายงานการซื้อขายหลักทรัพย์ – ตราสารทุน',
    'privatetitile2sub2list3': 'รายงานการซื้อขายหลักทรัพย์ – ตราสารหนี้',
    'privatetitile2sub2list4': 'รายงานทรัพย์สินสุทธิคงเหลือ',
    'privatetitile2sub2list5': 'รายงานการลงทุนที่อาจก่อให้เกิดความขัดแย้งทางผลประโยชน์',
    'privatetitile2sub2list6': 'รายงานการรับผลประโยชน์อื่น',
    'privatetitile2sub2list7': 'รายงานการใช้สิทธิออกเสียง (Voting)',
    'privatetitile2sub2list8': 'รายงานอื่นๆตามที่ลูกค้าร้องขอ',

    'privatetitile2sub3list1': 'ผู้จัดการกองทุนเข้ารายงานผลการดำเนินงานและแผนการลงทุนในช่วงถัดไป',
    'privatetitile2sub3list2': 'เชิญเข้าร่วมงานสัมมนาทางวิชาการต่างๆ เพื่อประโยชน์สูงสุดของลูกค้า',

    'privatetitile3': 'ดาวน์โหลดเอกสาร',

    'privatetitile4': 'รูปแบบการลงทุน และ ความเสี่ยง',
    'privatetitile4detail': 'บลจ.วรรณ ขอเสนอรูปแบบต่างๆ ของกองทุนส่วนบุคคล เพื่อให้สอดคล้องกับวัตถุประสงค์และผลตอบแทนในการลงทุนของลูกค้าดังนี้',

    'privatetitile5': 'Conservative Portfolio',
    'privatetitile5detail': 'เหมาะสมกับผู้ที่ต้องการผลตอบแทนที่แน่นอนและรับความเสี่ยงได้ในระดับต่ำ',
    'privatetitile5sub1': 'นโยบายการลงทุน',
    'privatetitile5sub1detail': 'จะเน้นลงทุนในตลาดเงินและตราสารหนี้ โดยอาจจะลงทุนในตลาดทุนหรือ ตลาดหลักทรัพย์บ้างในส่วนน้อย หรือไม่มีเลย แล้วแต่ระดับความเสี่ยงที่ลูกค้าจะยอมรับได้',
    'privatetitile5sub2': 'ผลตอบแทนที่คาดหวังจากการลงทุน',
    'privatetitile5sub2detail': 'มากกว่าอัตราดอกเบี้ยเงินฝาก',

    'privatetitile6': 'Moderate Portfolio',
    'privatetitile6detail': 'เหมาะสมกับผู้ที่ต้องการผลตอบแทนและรับความเสี่ยงได้ในระดับปานกลาง',
    'privatetitile6sub1': 'นโยบายการลงทุน',
    'privatetitile6sub1detail': 'จะเน้นลงทุนในตลาดเงินและตราสารหนี้ โดยอาจจะลงทุนในตลาดทุนหรือ ตลาดหลักทรัพย์บ้างในส่วนน้อย หรือไม่มีเลย แล้วแต่ระดับความเสี่ยงที่ลูกค้าจะยอมรับได้',
    'privatetitile6sub2': 'ผลตอบแทนที่คาดหวังจากการลงทุน',
    'privatetitile6sub2detail': 'มากกว่ากองทุน Conservative Portfolio',

    'privatetitile7': 'Aggressive Portfolio',
    'privatetitile7detail': 'เหมาะสมกับผู้ที่รับความเสี่ยงสูงเพื่อให้ได้ผลตอบแทนที่สูงในอนาคต',
    'privatetitile7sub1': 'นโยบายการลงทุน',
    'privatetitile7sub1detail': 'จะเน้นลงทุนในตลาดทุนหรือตลาดหลักทรัพย์เป็นอันดับแรก โดยอาจจะจัดสรรเงินทุนบางส่วนลงทุนในตลาดเงินบ้าง หรือไม่มีเลย โดยผลตอบแทนจะได้รับมาจากมูลค่าเพิ่มจากการลงทุนทั้งในระยะยาวและระยะปานกลาง รวมทั้งเงินปันผล',
    'privatetitile7sub2': 'ผลตอบแทนที่คาดหวังจากการลงทุน',
    'privatetitile7sub2detail': 'มากกว่า Moderate Portfolio',

    'contaxtitle': 'ติดต่อสอบถามข้อมูล',
    'contaxaddressline1': 'บริษัทหลักทรัพย์จัดการกองทุน วรรณ จำกัด',
    'contaxaddressline2': 'เลขที่ 989 สยามพิวรรธน์ทาวเวอร์ ชั้น 9, 24 ถ.พระราม 1 แขวงปทุมวัน เขตปทุมวัน กรุงเทพฯ 10330',
    'contaxdetail': 'ฝ่ายกองทุนส่วนบุคคล และกองทุนสำรองเลี้ยงชีพ',
    'contaxtel1': '0-2659-8749, 0-2659-8758',
    'contaxtel2': '0-2659-8764',
    'contaxemail': 'pd@one-asset.com',

    // provident-fund กองทุนสำรองเลี้ยงชีพ
    'providenttitle1': 'ภาพรวมกองทุน',
    'providenttitle1detail': 'กองทุนสำรองเลี้ยงชีพคืออะไร',
    'providenttitle1detailmenu1line1': 'จัดตั้งขึ้นโดยความ',
    'providenttitle1detailmenu1line2': 'สมัครใจของนายจ้าง',
    'providenttitle1detailmenu1line3': 'และลูกจ้าง',
    'providenttitle1detailmenu2line1': 'ประกอบด้วยเงินสะสม',
    'providenttitle1detailmenu2line2': 'จากลูกจ้าง และเงิน',
    'providenttitle1detailmenu2line3': 'สมทบจากนายจ้าง',
    'providenttitle1detailmenu3line1': 'เป็นเงินออมประเภท',
    'providenttitle1detailmenu3line2': 'ผูกพันระยะยาว',
    'providenttitle1detailmenu4line1': 'จดทะเบียนกองทุนเป็น',
    'providenttitle1detailmenu4line2': 'นิติบุคคลกับสำนักงาน',
    'providenttitle1detailmenu4line3': 'ก.ล.ต.',

    'providenttitle1sub1': 'วัตถุประสงค์ของกองทุนฯ',
    'providenttitle1sub1line1': 'เป็นหลักประกันที่มั่นคงในอนาคตของลูกจ้าง และครอบครัวเมื่อออกจากงาน เกษียณอายุ หรือ เสียชีวิต',
    'providenttitle1sub1line2': 'เป็นสวัสดิการของนายจ้างที่มีให้ลูกจ้าง',
    'providenttitle1sub1line3': 'สร้างแรงจูงใจในการทำงานของลูกจ้าง',
    'providenttitle1sub1line4': 'ส่งเสริมการระดมเงินออมของภาคเอกชน เพื่อพัฒนาเศรษฐกิจของประเทศ',

    'providenttitle1sub2': 'ประโยชน์ของกองทุนสำรองเลี้ยงชีพ',
    'providenttitle1sub2l': 'สำหรับนายจ้าง',
    'providenttitle1sub2lline1': 'เงินสมทบที่จ่ายให้กับลูกจ้าง หักเป็นค่าใช้จ่ายในการคำนวณภาษีของนายจ้างในปีที่จ่ายได้',
    'providenttitle1sub2lline2': 'สวัสดิการให้พนักงานที่มีคุณค่าต่อองค์กร',
    'providenttitle1sub2lline3': 'สร้างภาพลักษณ์ที่ดีต่อองค์กร',
    'providenttitle1sub2lline4': 'ลดการ Turn over ของพนักงาน',
    'providenttitle1sub2r': 'สำหรับลูกจ้าง',
    'providenttitle1sub2rline1': 'เงินสะสมสามารถนำไปลดหย่อนภาษีได้',
    'providenttitle1sub2rline2': 'สร้างวินัยการออม',
    'providenttitle1sub2rline3': 'มีเงินออมไว้ใช้เมื่อออกจากงานหรือเกษียณอายุ',
    'providenttitle1sub2rline4': 'เป็นหลักประกันให้ตนเองและครอบครัว และเพื่อใช้ชีวิตหลังเกษียณอย่างมั่นคง มีศักดิ์ศรี และพึ่งพาตนเองได้',

    'providenttitle2': 'โครงสร้างของกองทุนสำรองเลี้ยงชีพ',
    'providenttitle2detail': 'บุคคลที่เกี่ยวข้องเป็นใครกันบ้าง…คุ้นบ้างไหมเกี่ยวกับบุคคลดังต่อไปนี้?…',
    'providenttitle2detailline1': 'นายจ้าง เป็นคนที่มีส่วนสำคัญในการก่อกำเนิดกองทุนสำรองเลี้ยงชีพ หากปราศจากนายจ้างกองทุนสำรองเลี้ยงชีพก็ไม่สามารถเกิดขึ้นได้ ดังนั้นนายจ้างจึงเป็นบุคคลที่มีความหวังดีต่อลูกจ้าง ในการให้สวัสดิการที่ดีเพื่อให้ลูกจ้างมีเงินก้อนไว้ใช้เมื่อเกษียณอายุ ออกจากงานหรือออกจากกองทุน นายจ้างทำหน้าที่หลักคือการนำส่งเงินสะสมและสมทบเข้ากองทุน',
    'providenttitle2detailline2': 'ลูกจ้าง เป็นส่วนประกอบสำคัญอีกส่วนหนึ่งที่ทำให้เกิดกองทุนสำรองเลี้ยงชีพขึ้น มีหน้าที่ยอมให้นายจ้างหักค่าจ้างเป็นเงินสะสมเข้ากองทุน และต้องยินยอมปฏิบัติตามข้อกำหนดในข้อบังคับกองทุน',
    'providenttitle2detailline3p1': 'คณะกรรมการกองทุน แบ่งออกเป็น คณะกรรมการกองทุนฝ่ายนายจ้าง ซึ่งนายจ้างจะเป็นคนแต่งตั้ง อาจจะไม่ได้เป็นลูกจ้างก็ได้ คณะกรรมการกองทุนฝ่ายลูกจ้าง มาจากการเลือกตั้งของลูกจ้าง คนที่ได้รับเลือกจากลูกจ้างอาจไม่ได้เป็นสมาชิกกองทุนอยู่ก็ได้ ขึ้นอยู่กับเงื่อนไขที่จะกำหนดไว้ในข้อบังคับแต่ตามหลักแล้ว คณะกรรมการกองทุนฝ่ายลูกจ้างก็ควรจะเป็นสมาชิกอยู่ในกองทุนเอง เพราะคงไม่มีใครเข้าใจสมาชิกได้ดีเท่ากับสมาชิกด้วยกันเอง',
    'providenttitle2detailline3p2': 'คณะกรรมการกองทุนเป็นผู้ที่มีบทบาทสำคัญที่สุด เป็นตัวแทนของนายจ้างและสมาชิกในการบริหารกองทุน ดูแลเงินให้เกิดประโยชน์สูงสุดแก่สมาชิกภายใต้ความเสี่ยงที่ยอมรับได้ โดยมีหน้าที่ความรับผิดชอบในการประสานงานเพื่อจัดตั้งกองทุน คัดเลือกบริษัทจัดการ การกำหนดนโยบายการลงทุนที่สอดคล้องกับโครงสร้างของกองทุน หรือแก้ไขข้อบังคับกองทุน เป็นต้น ซึ่งจะเห็นว่าเป็นหน้าที่ที่สำคัญมากทีเดียว เนื่องจากอำนาจและหน้าที่บางอย่าง เช่น การแก้ไขข้อบังคับกองทุน จะมีผลผูกพันธ์กับสมาชิกให้ต้องปฏิบัติตาม และการกำหนดนโยบายการลงทุนจะมีผลต่อความมั่นคงและผลตอบแทนของกองทุน ดังนั้น ก่อนที่จะเลือกบุคคลมาเป็นตัวแทนของนายจ้างหรือสมาชิกควรพิจารณาอย่างละเอียดถี่ถ้วน เลือกคนดีที่มีความรู้ความสามารถ เป็นคนดีมีความตั้งใจจริง มีความเสียสละและสามารถอุทิศเวลาให้แก่เพื่อนๆ สมาชิกได้ในทำนองเดียวกัน คณะกรรมการกองทุนก็ต้องปฏิบัติหน้าที่ให้เป็นไปตามที่กฎหมายกำหนดด้วยความซื่อสัตย์สุจริต ระมัดระวังสมกับที่ได้รับความไว้วางใจจากนายจ้างและสมาชิก',
    'providenttitle2detailline4': 'สำนักงานคณะกรรมการกำกับหลักทรัพย์และตลาดหลักทรัพย์ หรือเรียกย่อๆ ว่าสำนักงาน “ก.ล.ต.” ทำหน้าที่ควบคุมดูแลบุคคลที่เกี่ยวข้องเกี่ยวกับการจัดการกองทุนสำรองเลี้ยงชีพทั้งหมด ไม่ว่าจะเป็นบริษัทจัดการ ผู้รับฝากทรัพย์สิน และผู้สอบบัญชี เป็นต้น และอีกบทบาทหน้าที่หนึ่งคือทำหน้าที่ในฐานะนายทะเบียนกองทุนสำรองเลี้ยงชีพในการรับจดทะเบียนจัดตั้งกองทุนการแก้ไขข้อบังคับกองทุน รวมทั้งควบคุมการปฏิบัติหน้าที่ของคณะกรรมการกองทุนด้วย',
    'providenttitle2detailline5': 'บริษัทจัดการ ทำหน้าที่ในการบริหารจัดการเงินของกองทุน โดยนำไปลงทุนเพื่อให้ออกดอกออกผลเพื่อเป็นประโยชน์แก่สมาชิกกองทุน ดังนั้นคณะกรรมการกองทุนต้องร่วมกันเลือกบริษัทจัดการที่เหมาะสมเข้ามาบริหารจัดการกองทุน โดยบริษัทจัดการจะต้องได้รับใบอนุญาตประกอบธุรกิจหลักทรัพย์ประเภทการจัดการกองทุนส่วนบุคคลซึ่งได้รับความเห็นชอบจากสำนักงานก.ล.ต. ทั้งนี้รายชื่อบริษัทจัดการที่ได้รับความเห็นชอบจากสำนักงานสามารถดูได้ที่',
    'providenttitle2detailline6': 'ผู้สอบบัญชี ทำหน้าที่ตรวจสอบรายงานทางการเงิน รับรองความถูกต้องของข้อมูลตามรายงานทางการเงินของกองทุน ก่อนที่จะทำการเลือกผู้สอบบัญชีของกองทุน จะต้องทราบว่าสมาชิกในกองทุนมีจำนวนเท่าใด หากกองทุนที่มีจำนวนสมาชิกไม่เกิน 100 ราย ให้ผู้สอบบัญชีรับอนุญาตทั่วไปตรวจสอบและแสดงความเห็นในงบการเงินของกองทุนได้แต่หากกองทุนมีสมาชิกเท่ากับหรือเกิน 100 ราย ต้องให้ผู้สอบบัญชีที่ได้รับความเห็นชอบจากสำนักงาน ก.ล.ต. ตรวจสอบและแสดงความเห็นในงบการเงินของกองทุน รายชื่อผู้สอบบัญชีที่ได้รับความเห็นชอบจากสำนักงานสามารถดูได้ที่',
    'providenttitle2detailline7': 'ผู้รับฝากทรัพย์สิน ทำหน้าที่ดูแลและเก็บรักษาทรัพย์สินของกองทุน ติดตามสิทธิประโยชน์ในเรื่องเงินปันผล และสิทธิต่างๆ ที่ได้จากการถือหุ้นในบริษัทที่กองทุนลงทุน โดยผู้รับฝากทรัพย์สินต้องได้รับความเห็นชอบจากสำนักงาน ก.ล.ต. ทั้งนี้รายชื่อผู้รับฝากทรัพย์สินที่ได้รับความเห็นชอบจากสำนักงานสามารถดูได้ที่',
    'providenttitle2detailline8': 'นายทะเบียนสมาชิก ทำหน้าที่จัดทำบัญชีรายชื่อสมาชิก จำนวนเงินสะสม เงินสมทบและผลประโยชน์ของสมาชิกแต่ละราย และจัดส่งรายงานรายตัวสมาชิกกองทุนสำรองเลี้ยงชีพให้สมาชิกทราบทุกงวด 6 เดือนของปีปฏิทิน โดยรายงานจะต้องแสดงจำนวนหน่วยกองทุนสำรองเลี้ยงชีพ มูลค่าต่อหน่วยกองทุนสำรองเลี้ยงชีพมูลค่าของเงินสะสมของสมาชิกกองทุนสำรองเลี้ยงชีพ เงินสมทบของนายจ้าง พร้อมทั้งผลประโยชน์ของเงินสะสมและเงินสมทบ โดยส่วนใหญ่แล้วบริษัทจัดการมักจะทำหน้าที่นายทะเบียนสมาชิกด้วยตัวเอง แต่ก็อาจมอบหมายให้บริษัทอื่นที่ได้รับอนุญาตจากสำนักงานก.ล.ต. เป็นนายทะเบียนสมาชิกแทนก็ได้',
    'providenttitle2detailline9': 'สมาคมกองทุนสำรองเลี้ยงชีพ (Association of Provident Fund) เป็นการรวมตัวกันของกองทุนสำรองเลี้ยงชีพ โดยเริ่มแรกจากการรวมตัวของกองทุนสำรองเลี้ยงชีพพนักงานรัฐวิสาหกิจ ต่อมาจึงขยายการรับสมาชิกในภาคเอกชนทำหน้าที่ในการเป็นตัวแทนของสมาชิกกองทุนสำรองเลี้ยงชีพในการควบคุมดูแลผลประโยชน์ที่กองทุนสำรองเลี้ยงชีพควรจะได้รับ รวมทั้งเป็นตัวแทนในการติดต่อประสานงานกับทางการและบุคคลต่างๆ ที่เกี่ยวข้อง รวบรวมแจ้งข้อมูลข่าวสารต่างๆ ที่เป็นประโยชน์ และส่งเสริมความรู้ให้กับคณะกรรมการกองทุนและสมาชิกกองทุนเป็นต้น',
    'providenttitle2detailline10': 'สมาคมบริษัทจัดการลงทุน (AIMC : Association of Investment Management Company) เป็นการรวมตัวกันของบริษัทจัดการ โดยสมาคมจะทำหน้าที่ควบคุมดูแลการปฏิบัติงานของบริษัทจัดการด้วยกันเอง เพื่อให้การประกอบธุรกิจเป็นไปอย่างมีประสิทธิภาพ รวมทั้งเป็นตัวแทนของบริษัทจัดการในการติดต่อประสานงานกับทางการในเรื่องต่างๆ',
    'providenttitle2detaillinelast': 'แหล่งที่มา : สำนักงานคณะกรรมการกำกับหลักทรัพย์และตลาดหลักทรัพย์',

    'providenttitle3': 'ดาวน์โหลดเอกสาร',

    'providenttitle4': 'รูปแบบการลงทุน และ ความเสี่ยง',
    'providenttitle4detail': 'บลจ.วรรณ ขอเสนอรูปแบบต่างๆ ของกองทุนส่วนบุคคล เพื่อให้สอดคล้องกับวัตถุประสงค์และผลตอบแทนในการลงทุนของลูกค้าดังนี้',

    'providenttitle5': 'Conservative Portfolio',
    'providenttitle5detail': 'เหมาะสมกับผู้ที่ต้องการผลตอบแทนที่แน่นอนและรับความเสี่ยงได้ในระดับต่ำ',
    'providenttitle5sub1': 'นโยบายการลงทุน',
    'providenttitle5sub1detail': 'จะเน้นลงทุนในตลาดเงินและตราสารหนี้ โดยอาจจะลงทุนในตลาดทุนหรือ ตลาดหลักทรัพย์บ้างในส่วนน้อย หรือไม่มีเลย แล้วแต่ระดับความเสี่ยงที่ลูกค้าจะยอมรับได้',
    'providenttitle5sub2': 'ผลตอบแทนที่คาดหวังจากการลงทุน',
    'providenttitle5sub2detail': 'มากกว่าอัตราดอกเบี้ยเงินฝาก',

    'providenttitle6': 'Moderate Portfolio',
    'providenttitle6detail': 'เหมาะสมกับผู้ที่ต้องการผลตอบแทนและรับความเสี่ยงได้ในระดับปานกลาง',
    'providenttitle6sub1': 'นโยบายการลงทุน',
    'providenttitle6sub1detail': 'จะเน้นลงทุนในตลาดเงินและตราสารหนี้ โดยอาจจะลงทุนในตลาดทุนหรือ ตลาดหลักทรัพย์บ้างในส่วนน้อย หรือไม่มีเลย แล้วแต่ระดับความเสี่ยงที่ลูกค้าจะยอมรับได้',
    'providenttitle6sub2': 'ผลตอบแทนที่คาดหวังจากการลงทุน',
    'providenttitle6sub2detail': 'มากกว่ากองทุน Conservative Portfolio',

    'providenttitle7': 'Aggressive Portfolio',
    'providenttitle7detail': 'เหมาะสมกับผู้ที่รับความเสี่ยงสูงเพื่อให้ได้ผลตอบแทนที่สูงในอนาคต',
    'providenttitle7sub1': 'นโยบายการลงทุน',
    'providenttitle7sub1detail': 'จะเน้นลงทุนในตลาดทุนหรือตลาดหลักทรัพย์เป็นอันดับแรก โดยอาจจะจัดสรรเงินทุนบางส่วนลงทุนในตลาดเงินบ้าง หรือไม่มีเลย โดยผลตอบแทนจะได้รับมาจากมูลค่าเพิ่มจากการลงทุนทั้งในระยะยาวและระยะปานกลาง รวมทั้งเงินปันผล',
    'providenttitle7sub2': 'ผลตอบแทนที่คาดหวังจากการลงทุน',
    'providenttitle7sub2detail': 'มากกว่า Moderate Portfolio',

    // app-calendar ปฏิทิน
    'calendarpagename': 'ปฏิทินกองทุน',
    'namefund': 'รายชื่อกองทุน',

    // app-favorite
    'backfund': 'กลับสู่หน้ากองทุนรวม',
    'favoritepagename': 'กองทุนที่ติดตาม',
    'favoritecancle': 'ยกเลิกติดตามมูลค่าหน่วยลงทุนกองทุนกด',
    'favoritenull': 'คุณยังไม่มีกองทุนที่สนใจ',

    // News
    'newsmenutab1': 'ข่าวสาร',
    'newsmenutab2': 'ประกาศ',
    'newsmenutab3': 'Earth Update',
    'newstime': 'ช่วงเวลา',
    'newstime1m': 'ข่าวย้อนหลัง 1 เดือน',
    'newstime3m': 'ข่าวย้อนหลัง 3 เดือน',
    'newstime6m': 'ข่าวย้อนหลัง 6 เดือน',
    'newstime9m': 'ข่าวย้อนหลัง 9 เดือน',
    'newstime12m': 'ข่าวย้อนหลัง 12 เดือน',

    // FundrecommComponent
    'fundrecommmenutab1': 'สรุปภาวะตลาด',
    'fundrecommmenutab2': 'Newsletter',
    'fundrecommmenutab3': 'VDO Clip',
    'fundrecommmenutab4': 'กองทุนแนะนำ',

    // Promotion
    'promotiontab1': 'โปรโมชั่น',
    'promotiontab2': 'สิทธิประโยชน์',

    // Site Map
    'sitemappagename': 'Site Map',
    'sitemaplistext1': 'ช่องทางบริการผู้ถือหน่วยลงทุน',
    'sitemapmenu2': 'กองทุน',

    // Jobs Apply
    'jobtitle': 'ตำแหน่งที่เปิดรับสมัคร',
    'jobspagename': 'ร่วมงานกับเรา',
    'jobsdetail': 'รายละเอียดงาน',
    'jobsnull': 'ไม่มีตำแหน่งที่เปิดรับ',

    // Faq
    'faqpagename': 'คำถามที่พบบ่อย',
    'faqtitle': 'คำถามยอดนิยม',
    'null': 'ไม่พบข้อมูล',
    'faq1': 'วิธีดาวน์โหลด ONEAM mobile Application เพื่อใช้งาน',
    'faq1detail': 'ลูกค้าสามารถศึกษาขั้นตอนการดาวน์โหลดได้ที่ <a href="https://www.one-asset.com/th/Benefit/detail/3" target="_blank"> https://www.one-asset.com/th/Benefit/detail/3 </a>',
    'faq2': 'วิธีการใช้งาน ONE live ผ่านทางเว็บไซต์ www.one-asset.com',
    'faq2detail': 'ลูกค้าสามารถเข้าไปที่เว็บไซด์',
    'faq2line1': '1. USERNAME หากจำไม่ได้กรุณาติดต่อที่ 02-6598888 กด 1',
    'faq2line2': '2. กด "ลืมรหัสผ่าน" ระบบจะให้ระบุ USERNAME และรหัสผ่านใหม่จะส่งที่อีเมลของท่าน กรุณาตรวจสอบทั้ง Inbox/Junk Mail/SPAM',
    'faq2line3': '3. จากนั้นกลับเข้าไปที่หน้า Log in เพื่อใส่ USERNAME และ PASSWORD (แนะนำให้ copy และ paste ลงในช่องต่างๆ) หมายเหตุ : PASSWORD ใหม่ที่ระบบส่งให้จะมีอายุ 15 นาที หากไม่นำไป Log in ภายในเวลาที่กำหนด จะต้องกดลืมรหัสผ่านใหม่อีกครั้ง',
    'faq2line4': '4. เมื่อ log in แล้วทำการตั้ง',
    'faq2line4list1': '- Username (เป็นตัวอักษรภาษาอังกฤษพิมพ์ใหญ่/พิมพ์เล็ก/ตัวเลข 6 ตัวขึ้นไป)',
    'faq2line4list2': '- PASSWORD (Old password:รหัสที่จัดส่งให้ใน e-mail New password,Confirm password : เป็นตัวอักษรภาษาอังกฤษพิมพ์ใหญ่ พิมพ์เล็ก ตัวเลข รวมกัน 8 ตัวขึ้นไป)',
    'faq2line4list3': '- PIN ตัวเลข 4 หลัก บันทึกรหัสผ่านใหม่เรียบร้อย กด Activated ที่อีเมลที่จัดส่งไปให้อีกครั้ง ภายใน 15 นาที',
    'faq3': 'วิธีการเปิดบัญชีสำหรับลูกค้าใหม่',
    'faq3detail': 'สามารถเปิดบัญชีกองทุนครั้งแรกผ่าน Application ONEAM หรือ <a href="https://onelive.one-asset.com/Home" target="_blank"> https://onelive.one-asset.com/Home </a>  ช่องทางใดช่องทางหนึ่ง',
    'faq3line1': '1. เปิดผ่าน Application ONEAM เลือก CLIENT LOGIN กดเลือก OPEN ACCOUNT',
    'faq3line2': '2. เปิดผ่าน <a href="https://onelive.one-asset.com/Home" target="_blank"> https://onelive.one-asset.com/Home </a> เลือกสมัครบริการเปิดบัญชี สามารถกรอกข้อมูลส่วนตัว ระบุเจ้าหน้าที่การตลาดและ Upload สำเนาบัตรประชาชนและสำเนาหน้าสมุดบัญชีธนาคารเซ็นสำเนารับรองถูกต้องทั้ง 2 ฉบับ หลังจากนั้นลูกค้าจะได้รับ USERNAME และ PASSWORD สามารถซื้อกองทุนได้ทันที และเจ้าหน้าที่จะโทรสัมภาษณ์ข้อมูลเพื่อประกอบการเปิดบัญชีเพิ่มเติมภายหลัง',
    'faq4': 'วิธีการตั้งราคา Auto Buy/Sell ผ่านทาง ONEAM Moblie Application',
    'faq4detail': 'ลูกค้าสามารถศึกษาขั้นตอนดาวน์โหลดได้ที่ <a href="https://www.one-asset.com/th/Benefit/detail/3" target="_blank"> https://www.one-asset.com/th/Benefit/detail/3 </a>',
    'faq5': 'ขั้นตอนการตัดบัญชีอัตโนมัติ',
    'faq5detailline1': 'ลูกค้าสามารถสมัครบริการหักบัญชีธนาคารอัตโนมัติ (Direct Debit) โดยดาวน์โหลดแบบฟอร์มได้ที่  <a href="https://www.one-asset.com/doc/192504_OR_2_4.pdf" target="_blank"> https://www.one-asset.com/doc/192504_OR_2_4.pdf </a>',
    'faq5detailline2': 'รบกวนกรอกฟอร์มหนังสือยินยอมให้หักบัญชีเงินฝากให้ครบถ้วน เซ็นชื่อทั้ง 2 ฉบับ โดยลงนามลายมือชื่อให้ตรงกับที่เปิดบัญชีไว้กับธนาคาร',
    'faq5detailtitle': 'เอกสารแนบ',
    'faq5list1': '1. สำเนาบัตรประชาชน (ลงนามรับรองสำเนาถูกต้อง) 1 ฉบับ',
    'faq5list2': '2. สำเนาหน้าสมุดบัญชีที่ต้องการหัก (ลงนามรับรองสำเนาถูกต้อง) 1 ฉบับ ',
    'faq5list2line1': 'จัดส่งเอกสารทั้งหมดมาตามที่อยู่บริษัท ธนาคารที่สามารถทำรายการหักบัญชีอัตโนมัติ (Direct Debit) ได้',
    'faq5list2line2': 'มีดังนี้ <a href="https://www.one-asset.com/fund-service-unit" target="_blank"> https://www.one-asset.com/fund-service-unit </a>',
    'faq6': 'วิธีการซื้อ Fund Gift Card',
    'faq6detailline1': 'การซื้อ Fund Gift Card ลูกค้าสามารถโทรสอบถาม ONEAM Call Center 02-659-8888 กด 1',
    'faq6detailline2': 'หรือ <a href="https://www.one-asset.com/th/Promotion/detail/2" target="_blank"> https://www.one-asset.com/th/Promotion/detail/2 </a>',
    'faq7': 'ตรวจสอบโปรโมชั่นและสิทธิประโยชน์ทางการตลาด ผ่าน ONEAM Moblie Application ',
    'faq7detailline1': 'ลูกค้าสามารถตรวจสอบโปรโมชั่นและสิทธิประโยชน์ได้ที่  <a href="https://www.one-asset.com/Promotion/promo" target="_blank"> https://www.one-asset.com/Promotion/promo </a>',
    'faq7detailline2': 'หรือ <a href="https://www.one-asset.com/th/Promotion/detail/2" target="_blank"> https://www.one-asset.com/th/Promotion/detail/2 </a>',
    'faq8': 'ตรวจสอบคะแนน ONE Points ',
    'faq8detailline1': 'ลูกค้าสามารถตรวจสอบคะแนน ONE Points ได้ที่ ONEAM Moblie Application',
    'faq8detailtitle': 'ขั้นตอน',
    'faq8list2line1': '1. Log in เข้าใช้งาน ONEAM Mobile Application',
    'faq8list2line2': '2. เลือกแถบเมนุ มุมซ้ายบน >>> เลือกแถบ >> Privilege',





    // oil
    // contact us

    // header
    'contactusheader': 'ติดต่อเรา',

    // title
    'contactustitle1': 'มีคำถามหรือความเห็นอยากบอกเรา? กรอกแบบฟอร์มด้านล่างได้เลย!',

    // form
    'contactusform1': 'ชื่อ',
    'contactusform2': 'เบอร์โทรศัพท์',
    'contactusform3': 'อีเมล',
    'contactusform4': 'เรื่องที่ต้องการติดต่อ',
    'contactusform5': 'รายละเอียด',
    'contactusform6': 'เปิดบัญชีซื้อขาย',
    'contactusform7': 'ข้อมูลกองทุน',
    'contactusform8': 'ร้องเรียน',
    'contactusform9': 'อื่นๆ',
    'contactusform10': 'ส่งข้อความ',
    'contactusform11': 'โปรดระบุ',


    // form error
    'contactusformerror1': 'กรุณากรอกชื่อ',
    'contactusformerror2': 'กรุณากรอกเบอร์โทรศัพท์',
    'contactusformerror3': 'กรุณากรอกอีเมล',
    'contactusformerror4': 'กรุณากรอกอีเมลให้ถูกต้อง',
    'contactusformerror5': 'โปรดระบุ',
    'contactusformerror6': 'กรุณาใส่รายละเอียด',

    // address
    'contactusaddress1': 'บริษัทหลักทรัพย์จัดการกองทุน วรรณ จำกัด',
    'contactusaddress2': '989 อาคารสยามพิวรรธน์ทาวเวอร์ ชั้น 9,24',
    'contactusaddress3': 'ถนนพระราม 1 แขวงปทุมวัน เขตปทุมวัน',
    'contactusaddress4': 'กรุงเทพฯ 10330',

    // detail contact
    'contactusdetail1': 'ซื้อขายกองทุน ติดต่อ ชั้น 24',
    'contactusdetail2': 'รถไฟฟ้าสยามทางออก 1',
    'contactusdetail3': '02-659-8888 กด 1',
    'contactusdetail4': 'ติดต่อลูกค้าสัมพันธ์',
    'contactusdetail5': '02-659-8860',

    // reply text
    'contactusreply1': 'ขอบคุณค่ะ',
    'contactusreply2': 'บริษัทหลักทรัพย์จัดการกองทุน วรรณ จำกัด',
    'contactusreply3': 'ได้รับข้อความของท่านแล้ว เจ้าหน้าที่จะทำการติดต่อไปในเวลาทำการค่ะ',
    'contactusreply4': 'กลับสู่หน้าหลัก',

    // about us

    // header
    'aboutusheader': 'เกี่ยวกับเรา',

    // menu
    'aboutusmenu1': 'ประวัติความเป็นมาของบริษัท',
    'aboutusmenu2': 'คณะกรรมการบริษัท และคณะผู้บริหาร',
    'aboutusmenu3': 'โครงสร้างองค์กร',

    // topic
    'aboutustopic1': 'ประวัติความเป็นมาของบริษัท',
    'aboutustopic2': 'คณะกรรมการบริษัท',
    'aboutustopic3': 'คณะผู้บริหาร',

    // detail
    'aboutusdetail1': 'บลจ.วรรณ จดทะเบียนจัดตั้งบริษัท เมื่อวันที่ <small>19 </small>มีนาคม พ.ศ. <small>2535</small> เป็นหนึ่งในกลุ่มบริษัทแรกที่ได้รับใบอนุญาตจากกระทรวงการคลังให้ประกอบธุรกิจการจัดการลงทุน นับจากที่รัฐบาลได้เปิดเสรีด้านการจัดการลงทุนภายใต้พระราชบัญญัติหลักทรัพย์และตลาดหลักทรัพย์ ปัจจุบัน (พ.ศ. <small>||yearNow||</small>) บลจ.วรรณ ดำเนินธุรกิจจัดการลงทุนมานานกว่า <small>||resultYear||</small> ปี โดยมีการดำเนินธุรกิจจัดการกองทุนอย่างครบวงจรให้แก่ลูกค้าทั้งบุคคลทั่วไป และสถาบันทางการเงินรวมถึงองค์กรต่างๆ ทั้งภาครัฐและเอกชนอีกทั้งเป็นบริษัทหลักทรัพย์จัดการกองทุนที่เติบโตอย่างรวดเร็วและต่อเนื่อง ภายใต้นโยบายการทำงานด้วยความเป็นมืออาชีพ บริหารการลงทุนด้วยกลยุทธ์ที่สอดคล้องกับนโยบายการลงทุนที่มุ่งหวังผลตอบแทนที่ดีภายใต้ระดับความเสี่ยงที่เหมาะสมและสอดคล้องกับสถานการณ์เศรษฐกิจทั้งในประเทศและต่างประเทศ บลจ.วรรณ ยังมีความมุ่งมั่นในการพัฒนาบุคลากรด้านต่างๆ อย่างต่อเนื่องเพื่อให้บริการด้วยความเป็นมืออาชีพอย่างดีที่สุดต่อผู้ลงทุน ดังคำสโลแกนที่ว่า <br> <b>ACTIVATE OPPORTUNITIES</b>',

    // slogan
    'aboutusslogan1': 'Growth Strivers',
    'aboutusslogan2': 'Innovation Performance',
    'aboutusslogan3': 'Substantial Precision',

    // list name
    'aboutusname1': 'คุณ จี้-เซิ่ง หนิว',
    'aboutusname2': 'คุณ นันทรัตน์ สุรักขกะ',
    'aboutusname3': 'คุณ พจน์ หะริณสุต',
    'aboutusname4': 'คุณ จิน-หลง เจิ้ง',
    'aboutusname5': 'คุณ ชิง ชิง ลี',
    'aboutusname6': 'คุณ เยียน-ชุน หลิน',
    'aboutusname7': 'คุณ พจน์ หะริณสุต',
    'aboutusname8': 'คุณ กฤช ปัทมวิชัยพร',
    'aboutusname9': 'คุณ มณฑล จุนชยะ',
    'aboutusname10': 'คุณ อลงกรณ์ ประธานราษฎร์นิกร',
    'aboutusname11': 'คุณ ปัทมเกสร์ อมาตยกุล',
    'aboutusname12': 'คุณ ชัยพฤกษ์ กุลกาญจนาธร',
    'aboutusname13': 'คุณ สุทธิโรจน์ สิทธิวัฒนานนท์',
    'aboutusname14': 'คุณ อรรณพ บุญคณานุรักษ์',
    'aboutusname15': 'คุณ ชิดชนก ส่งศิริ',

    // role
    'aboutusrole1': 'กรรมการ',
    'aboutusrole2': 'กรรมการ',
    'aboutusrole3': 'กรรมการ',
    'aboutusrole4': 'กรรมการ',
    'aboutusrole5': 'กรรมการและกรรมการตรวจสอบ',
    'aboutusrole6': 'กรรมการและกรรมการตรวจสอบ',
    'aboutusrole7': 'ประธานเจ้าหน้าที่บริหาร',
    'aboutusrole8': 'ประธานเจ้าหน้าที่บริหารปฏิบัติการ',
    'aboutusrole9': 'ประธานเจ้าหน้าที่บริหารการลงทุน',
    'aboutusrole10': 'ประธานเจ้าหน้าที่บริหารอสังหาริมทรัพย์และทรัสต์',
    'aboutusrole11': 'ประธานเจ้าหน้าที่บริหารการตลาด',
    'aboutusrole12': 'ประธานเจ้าหน้าที่บริหารการลงทุน กลุ่มจัดการลงทุนในประเทศ',
    'aboutusrole13': 'ประธานเจ้าหน้าที่บริหารการลงทุน กลุ่มจัดการลงทุนต่างประเทศ',
    'aboutusrole14': 'ประธานเจ้าหน้าที่บริหารกลยุทธ์และปฏิบัติการ',
    'aboutusrole15': 'ประธานเจ้าหน้าที่บริหารองค์กร',

    // fund service unit

    // header
    'fundunitheader': 'ช่องทางบริการผู้ถือหน่วยลงทุน',

    // button
    'fundunitdownloadbtn': 'ดาวน์โหลดแบบฟอร์มต่างๆ',
    'fundopenaccountpine': 'สนใจเปิดบัญชีออนไลน์ผ่านบริษัทในเครือของ บลจ.วรรณ',
    'fundopenaccountpineheader': 'เปิดบัญชีออนไลน์',
    'fundopenaccountpinemodal': 'เนื่องด้วย บลจ.วรรณ มีนโยบายปรับเปลี่ยนช่องทางการเปิดบัญชีออนไลน์ โดยท่านที่ประสงค์เปิดบัญชีออนไลน์เพื่อลงทุนในกองทุนของ บลจ.วรรณ ตั้งแต่วันที่ 1 ตุลาคม 2566 เป็นต้นไป ท่านสามารถเปิดบัญชีและลงทุนได้ที่ บล. ไพน์ เวลท์ โซลูชั่น (บริษัทในเครือ ของ บลจ.วรรณ)',

    // contact
    'fundunitcontact1': 'สำหรับผู้ที่สนใจลงทุนในกองทุนภายใต้การจัดการของ บลจ.วรรณ สามารถติดต่อขอข้อมูล เพื่อรับบริการการลงทุนได้ที่ บลจ.วรรณ โทร.02-659-8888 กด 1 หรือที่ตัวแทนสนับสนุนการขายและรับซื้อคืนที่ บลจ.วรรณ แต่งตั้ง',

    // topic
    'fundunittopic1': 'การซื้อหน่วยลงทุนครั้งแรก',
    'fundunittopic2': 'การรับเงินค่าขายคืน',
    'fundunittopic3': 'การโอนเงินเพื่อซื้อหน่วยลงทุน',

    // detail topic
    'fundunitdetailtopic1': 'สำหรับผู้ลงทุนรายใหม่ สามารถดำเนินการเปิดบัญชีกับ บลจ.วรรณ ได้ดังนี้',
    'fundunitdetailtopic2': 'กรณีประสงค์ที่จะรับเงินค่าขายคืนหน่วยลงทุน และ/หรือ เงินปันผล เข้าบัญชีธนาคาร โปรดแนบสำเนาหน้าแรกของสมุดบัญชีเงินฝากธนาคาร พร้อมกับรับรองสำเนาถูกต้อง โดยมีธนาคารที่สามารถรับชำระเงินค่าขายคืน 13 ธนาคารดังนี้',
    'fundunitdetailtopic3': 'โอนเงินเข้าบัญชีกลางที่ทาง บลจ. ได้จัดเตรียมไว้ [ บัญชีจองซื้อกองทุนเปิด บลจ.วรรณ จำกัด ] ดังมีรายละเอียดของบัญชี ดังนี้',

    // title
    'fundunittitle1': 'กรณีเปิดบัญชีทั่วไป',
    'fundunittitle2': 'กรณีเป็นผู้เยาว์',

    // detail title1
    'fundunittitle1detail1': 'กรอกรายละเอียดพร้อมเอกสารดังนี้',
    'fundunittitle1detail2': 'คำขอเปิดบัญชีกองทุนเปิด (Open-end Fund Account Opening Form)',
    'fundunittitle1detail3': 'แบบประเมินความเหมาะสมในการลงทุน (Suitability Test)',
    'fundunittitle1detail4': 'เอกสารประกอบการแสดงตัวตน',
    'fundunittitle1detail5': 'บุคคลธรรมดา',
    'fundunittitle1detail6': '- บัตรประจำตัวประชาชน/หนังสือเดินทาง/ใบต่างด้าว',
    // "fundunittitle1detail7": "- ทะเบียนบ้าน ที่ระบุเลขบัตรประจำตัวประชาชน",
    'fundunittitle1detail8': '- กรณีคนต่างชาติใช้ Work Permit หรือ VISA ที่มีอายุ 3 เดือนขึ้นไป',
    'fundunittitle1detail9': 'นิติบุคคล',
    'fundunittitle1detail10': '- หนังสือรับรองการจดทะเบียนที่นายทะเบียนออกให้ไม่เกิน 3 เดือน',
    'fundunittitle1detail11': '- บัตรประจำตัวประชาชน/หนังสือเดินทาง/ใบต่างด้าว ของผู้กรรมการผู้มีอำนาจลงนาม',
    // "fundunittitle1detail12": "- ทะเบียนบ้าน ที่ระบุเลขบัตรประจำตัวประชาชน ของผู้กรรมการผู้มีอำนาจลงนาม (กรณีที่บัตรแสดงตนไม่แสดงที่อยู่ไว้บนบัตร)",
    'fundunittitle1detail13': '- สำเนา บัญชีรายชื่อผู้ถือหุ้น (บอจ.5) (พร้อมรับรองสำเนาถูกต้อง)',
    'fundunittitle1detail14': '- รายงานการประชุมคณะกรรมการหรือหนังสือแสดงความประสงค์ขอเปิดบัญชีหรือทำธุรกรรม',
    'fundunittitle1detail15': 'สำเนาสมุดบัญชีเงินฝาก (หน้าแรก)',

    // detail title2
    'fundunittitle2detail1': 'กรอกรายละเอียดพร้อมเอกสารดังนี้',
    'fundunittitle2detail2': 'ผู้เยาว์ที่มีอายุ 15 ปี ขึ้นไปสามารถดำเนินการด้วยตนเอง โดยแนบสำเนา บัตรประจำตัวประชาชน / หนังสือเดินทาง / ใบต่างด้าว (พร้อมรับรองสำเนาถูกต้อง) โดยเจ้าของบัตร',
    'fundunittitle2detail3': 'ผู้เยาว์ที่มีอายุน้อยกว่า 15 ปี ให้ผู้ปกครอง (บิดา และมารดา) หรือผู้แทนโดยชอบธรรม เป็นผู้ลงนามโดยแนบเอกสารเพิ่มเติมดังนี้',
    'fundunittitle2detail4': 'สำเนา ใบสูติบัตรที่เป็นของผู้เยาว์ (พร้อมรับรองสำเนาถูกต้องร่วมกัน)',
    'fundunittitle2detail5': 'สำเนา ทะเบียนบ้านที่ปรากฏชื่อผู้เยาว์อาศัยอยู่ (พร้อมรับรองสำเนาถูกต้องร่วมกัน)',
    'fundunittitle2detail6': 'สำเนา บัตรประจำตัวประชาชน / หนังสือเดินทาง / ใบต่างด้าวของบิดา มารดา หรือผู้แทนโดยชอบธรรม (พร้อมรับรองสำเนาถูกต้อง) โดยเจ้าของบัตร',

    // detail topic2
    'fundunittopic2detail1': 'ธนาคาร กรุงศรีอยุธยา จำกัด (มหาชน)',
    'fundunittopic2detail2': 'ธนาคาร กรุงเทพ จำกัด (มหาชน)',
    'fundunittopic2detail3': 'ธนาคาร ซีไอเอ็มบี ไทย จำกัด (มหาชน)',
    'fundunittopic2detail4': 'ธนาคาร ออมสิน',
    'fundunittopic2detail5': 'ธนาคาร กสิกรไทย จำกัด (มหาชน)',
    'fundunittopic2detail6': 'ธนาคาร เกียรตินาคินภัทร จำกัด (มหาชน)',
    'fundunittopic2detail7': 'ธนาคาร กรุงไทย จำกัด (มหาชน)',
    'fundunittopic2detail8': 'ธนาคาร แลนด์ แอนด์ เฮ้าส์ จำกัด (มหาชน)',
    'fundunittopic2detail9': 'ธนาคาร ไทยพาณิชย์ จำกัด (มหาชน)',
    // "fundunittopic2detail10": "ธนาคาร ธนชาต จำกัด (มหาชน)",
    'fundunittopic2detail10': 'ธนาคาร ไทยเครดิต เพื่อรายย่อย จำกัด (มหาชน)',
    'fundunittopic2detail11': 'ธนาคาร ทิสโก้ จำกัด (มหาชน)',
    'fundunittopic2detail12': 'ธนาคาร ทหารไทยธนชาต จำกัด (มหาชน)',
    'fundunittopic2detail13': 'ธนาคาร ยูโอบี จำกัด (มหาชน)',

    // head table
    'fundunittablehead1': 'ชื่อบัญชี',
    'fundunittablehead2': 'ธนาคาร',
    'fundunittablehead3': 'สาขา',
    'fundunittablehead4': 'ประเภทบัญชี',
    'fundunittablehead5': 'เลขที่บัญชี',

    // row detail
    // row1
    'fundunitrow1detail1': 'บัญชีจองซื้อกองทุนเปิด บลจ.วรรณ จำกัด',
    'fundunitrow1detail2': 'กรุงศรีอยุธยา',
    'fundunitrow1detail3': 'สยามสแควร์',
    'fundunitrow1detail4': 'กระแสรายวัน',
    'fundunitrow1detail5': '123-0-03671-7',

    // row2
    'fundunitrow2detail1': 'บัญชีจองซื้อกองทุนเปิด บลจ.วรรณ จำกัด',
    'fundunitrow2detail2': 'กรุงเทพ',
    'fundunitrow2detail3': 'สยามสแควร์',
    'fundunitrow2detail4': 'กระแสรายวัน',
    'fundunitrow2detail5': '152-3-11123-3',

    // row3
    'fundunitrow3detail1': 'บัญชีจองซื้อกองทุนเปิด บลจ.วรรณ จำกัด',
    'fundunitrow3detail2': 'ซีไอเอมบี ไทย',
    'fundunitrow3detail3': 'สำนักสีลม',
    'fundunitrow3detail4': 'กระแสรายวัน',
    'fundunitrow3detail5': '800-0-19697-3',

    // row4
    'fundunitrow4detail1': 'บัญชีจองซื้อกองทุนเปิด บลจ.วรรณ จำกัด',
    'fundunitrow4detail2': 'ออมสิน',
    'fundunitrow4detail3': 'สยามสแควร์ วัน',
    'fundunitrow4detail4': 'กระแสรายวัน',
    'fundunitrow4detail5': '000-000-445-072',

    // row5
    'fundunitrow5detail1': 'บัญชีจองซื้อกองทุนเปิด บลจ.วรรณ จำกัด',
    'fundunitrow5detail2': 'กสิกรไทย',
    'fundunitrow5detail3': 'สยามสแควร์',
    'fundunitrow5detail4': 'กระแสรายวัน',
    'fundunitrow5detail5': '026-1-09287-5',

    // row6
    'fundunitrow6detail1': 'บัญชีจองซื้อกองทุนเปิด บลจ.วรรณ จำกัด',
    'fundunitrow6detail2': 'เกียรตินาคินภัทร',
    'fundunitrow6detail3': 'เซ็นทรัลเวิลด์',
    'fundunitrow6detail4': 'กระแสรายวัน',
    'fundunitrow6detail5': '100-0-00238-2',

    // row7
    'fundunitrow7detail1': 'บัญชีจองซื้อกองทุนเปิด บลจ.วรรณ จำกัด',
    'fundunitrow7detail2': 'กรุงไทย',
    'fundunitrow7detail3': 'สยามสแควร์',
    'fundunitrow7detail4': 'กระแสรายวัน',
    'fundunitrow7detail5': '052-6-08671-8',

    // row8
    'fundunitrow8detail1': 'บัญชีจองซื้อกองทุนเปิด บลจ.วรรณ จำกัด',
    'fundunitrow8detail2': 'แลนด์ แอนด์ เฮ้าส์',
    'fundunitrow8detail3': 'สำนักลุมพินี',
    'fundunitrow8detail4': 'กระแสรายวัน',
    'fundunitrow8detail5': '889-1-01067-2',

    // row9
    'fundunitrow9detail1': 'บัญชีจองซื้อกองทุนเปิด บลจ.วรรณ จำกัด',
    'fundunitrow9detail2': 'ไทยพาณิชย์',
    'fundunitrow9detail3': 'สยามสแควร์',
    'fundunitrow9detail4': 'กระแสรายวัน',
    'fundunitrow9detail5': '038-3-07483-3',

    // row10
    'fundunitrow10detail1': 'บัญชีจองซื้อกองทุนเปิด บลจ.วรรณ จำกัด',
    'fundunitrow10detail2': 'ธนชาต',
    'fundunitrow10detail3': 'อาคารสยามกิตติ์',
    'fundunitrow10detail4': 'กระแสรายวัน',
    'fundunitrow10detail5': '044-3-00149-5',

    // row11
    'fundunitrow11detail1': 'บัญชีจองซื้อกองทุนเปิด บลจ.วรรณ จำกัด',
    'fundunitrow11detail2': 'ไทยเครดิต',
    'fundunitrow11detail3': 'สำนักธุรกิจรัชดาภิเษก',
    'fundunitrow11detail4': 'กระแสรายวัน',
    'fundunitrow11detail5': '777-1-00500-6',

    // row12
    'fundunitrow12detail1': 'บัญชีจองซื้อกองทุนเปิด บลจ.วรรณ จำกัด',
    'fundunitrow12detail2': 'ทิสโก้',
    'fundunitrow12detail3': 'สำนักงานใหญ่',
    'fundunitrow12detail4': 'กระแสรายวัน',
    'fundunitrow12detail5': '0001-114-005061-0',

    // row13
    'fundunitrow13detail1': 'บัญชีจองซื้อกองทุนเปิด บลจ.วรรณ จำกัด',
    'fundunitrow13detail2': 'ทหารไทยธนชาต',
    'fundunitrow13detail3': 'สำนักพหลโยธิน',
    'fundunitrow13detail4': 'กระแสรายวัน',
    'fundunitrow13detail5': '001-1-54342-8',

    // row14
    'fundunitrow14detail1': 'บัญชีจองซื้อกองทุนเปิด บลจ.วรรณ จำกัด',
    'fundunitrow14detail2': 'ยูโอบี',
    'fundunitrow14detail3': 'สยามสแควร์',
    'fundunitrow14detail4': 'กระแสรายวัน',
    'fundunitrow14detail5': '772-3-63112-6',

    // bottomdetail
    'fundunitbottomdetail1': 'หลังจากที่ท่าน ได้ทำการโอนเงินโดยวิธีหนึ่งวิธีใดข้างต้นนั้นแล้ว กรุณากรอกแบบฟอร์มใบคำสั่งซื้อหน่วยลงทุน พร้อมกันนี้ ให้แนบสำเนาการโอนเงิน ส่งโทรสารมายัง ฝ่ายลูกค้าสัมพันธ์และสนับสนุนธุรกิจ หมายเลขโทรสาร 02-659-8860-1 ในกรณีที่ท่านไม่สะดวกในขั้นตอนดังกล่าว ท่านสามารถติดต่อเจ้าหน้าที่',
    'fundunitbottomdetail2': 'หมายเลขโทรศัพท์ 02-659-8888 กด 1',
    'fundunitbottomdetail3': 'ฝ่ายลูกค้าสัมพันธ์และสนับสนุนธุรกิจ',
    'fundunitbottomdetail4': 'เพื่อที่ทางบริษัท จะจัดส่งเจ้าหน้าที่ไปรับแบบฟอร์มใบคำสั่งซื้อหน่วยลงทุนและเช็คค่าซื้อ หน่วยลงทุนที่ท่านโดยตรง',
    'fundunitbottomdetail5': 'เพื่อเป็นการเพิ่มความสะดวกใน',
    'fundunitbottomdetail6': 'การสั่งซื้อหน่วยลงทุนแบบสม่ำเสมอ (Standing Instruction)',
    'fundunitbottomdetail7': 'ปัจจุบัน ทางบริษัทได้เปิดให้ผู้ถือหน่วยลงทุน สามารถ ทำรายการหักบัญชีอัตโนมัติ (Direct Debit) ผ่าน 12 ธนาคาร ดังต่อไปนี้',

    // list banks
    'fundunitlistbank1': 'ธนาคาร กรุงศรีอยุธยา จำกัด (มหาชน)',
    'fundunitlistbank2': 'ธนาคาร กรุงเทพ จำกัด (มหาชน)',
    'fundunitlistbank3': 'ธนาคาร ซีไอเอ็มบี ไทย จำกัด (มหาชน)',
    'fundunitlistbank4': 'ธนาคาร กสิกรไทย จำกัด (มหาชน)',
    'fundunitlistbank5': 'ธนาคาร เกียรตินาคินภัทร จำกัด (มหาชน)',
    'fundunitlistbank6': 'ธนาคาร กรุงไทย จำกัด (มหาชน)',
    'fundunitlistbank7': 'ธนาคาร แลนด์ แอนด์ เฮ้าส์ จำกัด (มหาชน)',
    'fundunitlistbank8': 'ธนาคาร ไทยพาณิชย์ จำกัด (มหาชน)',
    // "fundunitlistbank9": "ธนาคาร ธนชาต จำกัด (มหาชน)",
    'fundunitlistbank9': 'ธนาคาร ไทยเครดิต เพื่อรายย่อย จำกัด (มหาชน)',
    'fundunitlistbank10': 'ธนาคาร ทิสโก้ จำกัด (มหาชน)',
    'fundunitlistbank11': 'ธนาคาร ทหารไทยธนชาต จำกัด (มหาชน)',
    'fundunitlistbank12': 'ธนาคาร ยูโอบี จำกัด (มหาชน)',

    // summary
    // "fundunitsummary1": "เพียงแต่ท่านกรอกแบบฟอร์มใบคำสั่งซื้อหน่วยลงทุนอัตโนมัติ พร้อมกันนี้ให้แนบสำเนาสมุดเงินฝากที่ท่านต้องการให้หักบัญชี ยื่นต่อเจ้าหน้าที่ฝ่ายลูกค้าสัมพันธ์และสนับสนุนธุรกิจของบริษัท เมื่อทางบริษัท ได้รับอนุมัติจากธนาคารเจ้าของบัญชีเรียบร้อยแล้ว ทางบริษัทจะแจ้งให้ท่านทราบต่อไป โดยขั้นตอนนี้จะใช้เวลาประมาณ 1 เดือน",
    'fundunitsummary1': '',
    // "fundunitsummary2": "หมายเหตุ",
    'fundunitsummary2': '',
    // "fundunitsummary3": ": ปัจจุบัน ทางบริษัทจะทำการหักบัญชีอัตโนมัติทุกวันที่ 1 และ 16 ของเดือนเท่านั้น",
    'fundunitsummary3': '',

    // download form (fund service unit)
    'downloadfromunitheader': 'ดาวน์โหลดแบบฟอร์ม',


    // Plan Your Investment

    // header
    'planinvestmentheader': 'วางแผนการลงทุน',

    // menu
    'planinvestmentmenu1': 'เรียนรู้การลงทุน',
    'planinvestmentmenu2': 'เริ่มลงทุนอย่างไร',
    'planinvestmentmenu3': 'จัดพอร์ตการลงทุน',

    // step topic
    'planinvestmentsteptopic1': 'ขั้นที่ 1: เลือกเป้าหมายของคุณ',

    // target title
    'planinvestmenttargettitle1': 'มือใหม่หัดลงทุน',
    'planinvestmenttargettitle2': 'เพื่อเป้าหมาย',
    'planinvestmenttargettitle3': 'เพื่อเกษียณ',

    // target description
    'planinvestmenttargetdesc1': 'วางแผนทางการเงินและเตรียมตัวให้พร้อมสำหรับผู้เริ่มต้นลงทุน',
    'planinvestmenttargetdesc2': 'วางแผนทางการเงินและเตรียมตัวให้พร้อมเพื่อพิชิตเป้าหมายทางการเงิน',
    'planinvestmenttargetdesc3': 'วางแผนทางการเงินและเตรียมตัวให้พร้อมสำหรับการใช้จ่ายในวัยเกษียณ',

    // newbeeActive
    'newbeeactive1': 'วางแผนทางการเงินและเตรียมตัวให้พร้อมสำหรับผู้เริ่มต้นลงทุน',
    // "newbeeactive1": "วางแผนทางการเงินและเตรียมตัวให้พร้อมสำหรับผู้เริ่มต้นลงทุน",
    // "newbeeactive1": "วางแผนทางการเงินและเตรียมตัวให้พร้อมสำหรับผู้เริ่มต้นลงทุน",
    // "newbeeactive1": "วางแผนทางการเงินและเตรียมตัวให้พร้อมสำหรับผู้เริ่มต้นลงทุน",
    // "newbeeactive1": "วางแผนทางการเงินและเตรียมตัวให้พร้อมสำหรับผู้เริ่มต้นลงทุน",
    // "newbeeactive1": "วางแผนทางการเงินและเตรียมตัวให้พร้อมสำหรับผู้เริ่มต้นลงทุน",
    // "newbeeactive1": "วางแผนทางการเงินและเตรียมตัวให้พร้อมสำหรับผู้เริ่มต้นลงทุน",
    // "newbeeactive1": "วางแผนทางการเงินและเตรียมตัวให้พร้อมสำหรับผู้เริ่มต้นลงทุน",
    // "newbeeactive1": "วางแผนทางการเงินและเตรียมตัวให้พร้อมสำหรับผู้เริ่มต้นลงทุน",
    // "newbeeactive1": "วางแผนทางการเงินและเตรียมตัวให้พร้อมสำหรับผู้เริ่มต้นลงทุน",

    // Investing By Risk

    // Newbee
    'investingbyrisknewbee': 'ชื่อ - นามสกุล',

    // Topic
    'investingbyrisktopic': 'แบบทดสอบการรับความเสี่ยง',

    // Note
    'investingbyrisknote1': 'กรุณาตอบคําถามให้ครบทุกข้อ',
    'investingbyrisknote2': 'เพื่อใช้ในการประเมินความเหมาะสมในการลงทุนให้สอดคล้องกับความเสี่ยงที่ยอมรับได้',
    'investingbyrisknoteerror': 'กรุณากรอกแบบฟอร์มให้ครบถ้วน',

    // Q&A
    // 1
    'investingbyriskquestion1': 'ปัจจุบันท่านอายุ',
    'investingbyriskq1answer1': 'มากกว่า 55 ปี',
    'investingbyriskq1answer2': '45 - 55 ปี',
    'investingbyriskq1answer3': '35 - 44 ปี',
    'investingbyriskq1answer4': 'น้อยกว่า 35 ปี',

    // 2
    'investingbyriskquestion2': 'ปัจจุบันท่านมีภาระทางการเงินและค่าใช้จ่ายประจํา เช่น ค่าผ่อนบ้าน รถ ค่าใช้จ่ายส่วนตัว และค่าเลี้ยงดูครอบครัว เป็นสัดส่วนเท่าใด',
    'investingbyriskq2answer1': 'มากกว่าร้อยละ 75 ของรายได้ทั้งหมด',
    'investingbyriskq2answer2': 'ระหว่างร้อยละ 50 ถึงร้อยละ 75 ของรายได้ทั้งหมด',
    'investingbyriskq2answer3': 'ระหว่างร้อยละ 25 ถึงร้อยละ 50 ของรายได้ทั้งหมด',
    'investingbyriskq2answer4': 'น้อยกว่าร้อยละ 25 ของรายได้ทั้งหมด',

    // 3
    'investingbyriskquestion3': 'ท่านมีสถานภาพทางการเงินในปัจจุบันอย่างไร',
    'investingbyriskq3answer1': 'มีทรัพย์สินน้อยกว่าหนี้สิน',
    'investingbyriskq3answer2': 'มีทรัพย์สินเท่ากับหนี้สิน',
    'investingbyriskq3answer3': 'มีทรัพย์สินมากกว่าหนี้สิน',
    'investingbyriskq3answer4': 'มีความมั่นใจว่ามีเงินออมหรือเงินลงทุนเพียงพอสําหรับการใช้ชีวิตหลังเกษียณอายุแล้ว',

    // 4
    'investingbyriskquestion4': 'ท่านเคยมีประสบการณ์หรือมีความรู้ในการลงทุนในทรัพย์สินกลุ่มใดต่อไปนี้บ้าง (เลือกได้มากกว่า 1 ข้อ)',
    'investingbyriskq4answer1': 'เงินฝากธนาคาร',
    'investingbyriskq4answer2': 'พันธบัตรรัฐบาล หรือกองทุนรวมพันธบัตรรัฐบาล',
    'investingbyriskq4answer3': 'หุ้นกู้ หรือกองทุนรวมตราสารหนี้',
    'investingbyriskq4answer4': 'หุ้นสามัญ หรือกองทุนรวมหุ้น หรือสินทรัพย์อื่นที่มีความเสี่ยงสูง',
    'investingbyriskq4note': 'หากตอบหลายข้อให้เลือกข้อที่คะแนนสูงสุด',

    // 5
    'investingbyriskquestion5': 'ระยะเวลาทีท่านคาดว่าจะไม่มีความจำเป็นต้องใช้เงินลงทุนนี้',
    'investingbyriskq5answer1': 'ไม่เกิน 1 ปี',
    'investingbyriskq5answer2': '1 ถึง 3 ปี',
    'investingbyriskq5answer3': '3 ถึง 5 ปี',
    'investingbyriskq5answer4': 'มากกว่า 5 ปี',

    // 6
    'investingbyriskquestion6': 'วัตถุประสงค์ในการลงทุนของท่านคือ',
    'investingbyriskq6answer1': 'เน้นเงินต้นต้องปลอดภัยและได้รับผลตอบแทนสม่ำเสมอแต่ต่ำได้',
    'investingbyriskq6answer2': 'เน้นโอกาสได้รับผลตอบแทนที่สม่ำเสมอแต่อาจเสี่ยงที่จะสูญเสียเงินต้นได้บ้าง',
    'investingbyriskq6answer3': 'เน้นโอกาสได้รับผลตอบแทนที่สูงขึ้น แต่อาจเสี่ยงที่จะสูญเสียเงินต้นได้มากขึ้น',
    'investingbyriskq6answer4': 'เน้นผลตอบแทนสูงสุดในระยะยาว แต่อาจเสี่ยงที่จะสูญเงินต้นส่วนใหญ่ได้',

    // 7
    'investingbyriskquestion7': 'เมื่อพิจารณารูปแสดงตัวอย่างผลตอบแทนของกลุ่มการลงทุนที่อาจเกิดขึ้นด้านล่าง ท่านเต็มใจที่จะลงทุนในกลุ่มการลงทุนใดมากที่สุด',
    'investingbyriskq7answer1': 'กลุ่มการลงทุนที่ 1 มีโอกาสได้รับผลตอบแทน 2.5% โดยไม่ขาดทุนเลย',
    'investingbyriskq7answer2': 'กลุ่มการลงทุนที่ 2 มีโอกาสได้รับผลตอบแทนสูงสุด 7% แต่อาจมีผลขาดทุนได้ถึง 1%',
    'investingbyriskq7answer3': 'กลุ่มการลงทุนที่ 3 มีโอกาสได้รับผลตอบแทนสูงสุด 15% แต่อาจมีผลขาดทุนได้ถึง 5%',
    'investingbyriskq7answer4': 'กลุ่มการลงทุนที่ 4 มีโอกาสได้รับผลตอบแทนสูงสุด 25% แต่อาจมีผลขาดทุนได้ถึง 15%',

    // 8
    'investingbyriskquestion8': 'ถ้าท่านเลือกลงทุนในทรัพย์สินที่มีโอกาสได้รับผลตอบแทนมาก แต่มีโอกาสขาดทุนสูงด้วยเช่นกัน ท่านจะรู้สึกอย่างไร',
    'investingbyriskq8answer1': 'กังวลและตื่นตระหนกกลัวขาดทุน',
    'investingbyriskq8answer2': 'ไม่สบายใจแต่พอเข้าใจได้บ้าง',
    'investingbyriskq8answer3': 'เข้าใจและรับความผันผวนได้ในระดับหนึ่ง',
    'investingbyriskq8answer4': 'ไม่กังวลกับโอกาสขาดทุนสูง และหวังกับผลตอบแทนที่อาจจะได้รับสูงขึ้น',

    // 9
    'investingbyriskquestion9': 'ท่านจะรู้สึกกังวล/รับไม่ได้ เมื่อมูลค่าเงินลงทุนของท่านมีการปรับตัวลดลงในสัดส่วนเท่าใด',
    'investingbyriskq9answer1': '5% หรือน้อยกว่า',
    'investingbyriskq9answer2': 'มากกว่า 5% - 10%',
    'investingbyriskq9answer3': 'มากกว่า 10% - 20%',
    'investingbyriskq9answer4': 'มากกว่า 20% ขึ้นไป',

    // 10
    'investingbyriskquestion10': 'หากปีที่แล้วท่านลงทุนไป 100,000 บาท ปีนี้ท่านพบว่ามูลค่าเงินลงทุนลดลงเหลือ 85,000 บาท ท่านจะทําอย่างไร',
    'investingbyriskq10answer1': 'ตกใจ และต้องการขายการลงทุนที่เหลือทิ้ง',
    'investingbyriskq10answer2': 'กังวลใจ และจะปรับเปลี่ยนการลงทุนบางส่วนไปในทรัพย์สินที่เสี่ยงน้อยลง',
    'investingbyriskq10answer3': 'อดทนถือต่อไปได้ และรอผลตอบแทนปรับตัวกลับมา',
    'investingbyriskq10answer4': 'ยังมั่นใจ เพราะเข้าใจว่าต้องลงทุนระยะยาวและจะเพิ่มเงินลงทุน ในแบบเดิมเพื่อเฉลี่ยต้นทุน',

    // 11
    'investingbyriskq11note1': 'สําหรับการลงทุนในตราสารอนุพันธ์',
    'investingbyriskq11note2': '(คําถามข้อ 11 และ 12 ใช้เป็นข้อมูลเพื่อประกอบการให้คำแนะนํา)',
    'investingbyriskquestion11': 'การลงทุนในตราสารอนุพันธ์ หากการลงทุนประสบความสําเร็จ ท่านจะได้รับผลตอบแทนในอัตราที่สูงมาก แต่หากการลงทุนล้มเหลวท่านอาจจะสูญเงินลงทุนทั้งหมด และอาจต้องลงเงินชดเชยเพิ่มบางส่วนท่านยอมรับ ได้เพียงใด',
    'investingbyriskq11answer1': 'ไม่ได้',
    'investingbyriskq11answer2': 'ได้บ้าง',
    'investingbyriskq11answer3': 'ได้',

    // 12
    'investingbyriskq12note': 'สําหรับการลงทุนในต่างประเทศ',
    'investingbyriskquestion12': 'นอกเหนือจากความเสี่ยงในการลงทุนแล้ว ท่านสามารถรับความเสี่ยงด้านอัตราแลกเปลี่ยนได้เพียงใด',
    'investingbyriskq12answer1': 'ไม่ได้',
    'investingbyriskq12answer2': 'ได้บ้าง',
    'investingbyriskq12answer3': 'ได้',

    // sumary
    'investingbyrisksumary': 'แสดงผลการประเมิน',


    // calculate step2
    // step topic
    'step2topic1': 'ผลลัพธ์พิชิตเป้าหมายทางการเงินของคุณ',

    // title
    'step2title1': 'สรุปผลลัพธ์ตามเป้าหมายของคุณ',
    'step2title2': 'เป้าหมายเงินออมของคุณ',
    'step2title3': 'การลงทุนเพื่อพิชิตเป้าหมายของคุณ',
    'step2title4': 'เงื่อนไขการให้บริการ',

    // detail
    // title1
    // column 1
    'step2t1col1detail1': 'คุณมีระยะเวลาในการลงทุน',
    'step2t1col1detail2': 'ปี',
    'step2t1col1detail3': 'โดยต้องใช้จ่ายหลังเกษียณอีก',
    'step2t1col1detail4': 'ปี',

    // column 2
    'step2t1col2detail1': 'หากคุณวางแผนที่จะใช้จ่ายหลังเกษียณ',
    'step2t1col2detail2': 'บาท/เดือน',
    'step2t1col2detail3': 'คุณควรมีเงินเก็บเมื่อเกษียณอายุ',
    'step2t1col2detail4': 'บาท',
    'step2t1col2detail5': 'จากเงินออมปัจจุบัน หากลงทุนด้วยกองทุนที่ บลจ.วรรณแนะนำ ผลตอบแทนคาดหวัง ณ วันเกษียณ คือ',
    'step2t1col2detail6': 'บาท',

    // column 3
    'step2t1col3detail1': 'เพื่อให้ได้ตามเป้าหมาย',
    'step2t1col3detail2': 'เงินออมเมื่อเกษียณดังกล่าว คุณควรสร้างผลตอบแทนการลงทุนประมาณ',
    'step2t1col3detail3': 'บาทซึ่งคาดว่าคุณจะได้ผลตอบแทนที่',
    'step2t1col3detail5': '% เพื่อเพียงพอกับการใช้จ่ายในอนาคต ขอแนะนำ',
    'step2t1col3detail4': 'การกระจายการลงทุนที่',

    // title2
    // column 1
    'step2t2col1detail1': 'คุณมีเงินออมทั้งหมด',
    'step2t2col1detail2': 'บาท',

    // column 2
    'step2t2col2detail1': 'เป้าหมายเงินออมของคุณ',
    'step2t2col2detail2': 'บาท',

    // column 3
    'step2t2col3detail1': 'คุณจำเป็นต้องออมเงินเพิ่ม',
    'step2t2col3detail2': 'บาท',

    // column 4
    'step2t2col4detail1': 'หรือออมเงินต่อเดือน',
    'step2t2col4detail2': 'บาท',

    // title3
    'step2t3detail1': 'รายชื่อกองทุนแนะนำสำหรับคุณ โดยมีผลตอบแทนที่คาดหวังประมาณ',
    'step2t3detail2': 'โดยลงทุนประมาณ',
    'step2t3detail3': 'บาทต่อเดือน',
    'step2t3detail4': 'กองทุนแนะนำ',

    // remark
    'step2remark1': 'สีแดง: กองทุนนี้มีระดับความเสี่ยงสูงกว่าระดับความเสี่ยงที่ท่านยอมรับได้จากแบบประเมิน กรุณารับทราบความเสี่ยงกองทุนเพิ่มเติมก่อนยืนยันการลงทุน',
    'step2remark2': 'สีน้ำเงิน: กองทุนนี้เป็นกองทุนที่ให้สิทธิประโยชน์ทางภาษี ก่อนการลงทุนผู้ลงทุนควรศึกษาข้อมูลเกี่ยวกับสิทธิประโยชน์ทางภาษีที่ระบุไว้ในคู่มือการลงทุน',

    // subtitle
    'step2subtitle1': 'ข้อสงวนสิทธิ์การใช้งาน',
    'step2subtitle1detail': 'โปรแกรมคำนวณการเกษียณอายุนี้ สร้างขึ้นเพื่อวัตถุประสงค์ให้เกิดความเข้าใจในแผนการออมเพื่อการเกษียณเท่านั้น ผลตอบแทนอาจเปลี่ยนแปลงภายใต้เงื่อนไขที่กำหนด ผลประกอบการในอดีตไม่ได้เป็นเครื่องบ่งชี้ผลประกอบการในอนาคต การลงทุนมีความเสี่ยง ผู้ลงทุนควรศึกษาข้อมูลก่อนตัดสินใจลงทุน การคำนวณย้อนหลังไม่ได้รวมอยู่ในค่าธรรมเนียมและอาจได้ผลตอบแทนที่ไม่ถูกต้อง เราไม่มีส่วนรับผิดชอบต่อผลตอบแทนที่ได้รับ ความสูญหาย หรือความเสียหาย อันเกิดจากการใช้ข้อมูลหรือการนำเสนอข้อมูลนี้',

    'step2subtitle2': 'แบบฟอร์มการคำนวณนี้อยู่ภายใต้สมมติฐานดังต่อไปนี้',
    'step2subtitle2detail1': 'ผลตอบแทนที่คาดว่าจะได้รับคำนวณจากข้อมูลย้อนหลังตั้งแต่ปีพ.ศ. 2548 - 2558 ของกองทุนรวม ONEAM ในแต่ละประเภทสินทรัพย์ หากไม่มีข้อมูลย้อนหลัง เกณฑ์มาตรฐานที่เหมาะสมสำหรับแต่ละชั้นของสินทรัพย์จะถูกนำมาใช้แทน',
    'step2subtitle2detail2': 'แสดงผลความน่าจะเป็นของความสำเร็จในการลงทุนเมื่อเกษียน โดยความน่าจะเป็นคำนวณจากสมมติฐานมูลค่าการลงทุนปกติโดยใช้ค่าเฉลี่ยของมูลค่าในอนาคตของเงินลงทุนเมื่อเกษียณและส่วนเบี่ยงเบนมาตรฐาน',
    'step2subtitle2detail3': 'ความเสี่ยงด้านการลงทุนวัดจากความผันผวนของแผนการลงทุน',
    'step2subtitle2detail4': 'การกระจายผลตอบแทนตามปกติจะไม่ถูกนำมาคำนวณมูลค่าปัจจุบันและในอนาคต',

    // button
    'step2button': 'ขอคำแนะนำจากเจ้าหน้าที่',

    // calculate step3
    // header
    'step3header': 'วางแผนการลงทุน',

    // topic
    'step3topic1': 'โปรดกรอกข้อมูลของคุณ',
    'step3topic2': 'เพื่อรับการแนะนำการวางแผนการลงทุน',

    // information
    'step3info1': 'ชื่อ',
    'step3info2': 'นามสกุล',
    'step3info3': 'เบอร์โทรศัพท์',
    'step3info4': 'อีเมล',

    // error msg
    'step3error1': 'กรุณากรอกชื่อ',
    'step3error2': 'กรุณากรอกเบอร์โทรศัพท์',
    'step3error3': 'กรุณากรอกเบอร์โทรศัพท์ให้ถูกต้อง',

    // button
    'step3backbtn': 'ย้อนกลับ',
    'step3comfirmbtn': 'ตกลง',

    // alert msg
    'step3msg1': 'ขอบคุณค่ะ',
    'step3msg2': 'บริษัทหลักทรัพย์จัดการกองทุน วรรณ จำกัด',
    'step3msg3': 'ได้รับข้อความของท่านแล้ว เจ้าหน้าที่จะทำการติดต่อไปในเวลาทำการค่ะ',

    // Fund Detail TH
    // Morning Star
    'funddetailthmorning1': 'ดาวจากมอร์นิ่งสตาร์',
    'funddetailthmorning2': 'ณ. วันที่',

    // header button
    'funddetailthheaderbtn1': 'เปรียบเทียบกองทุน',
    'funddetailthheaderbtn2': 'ซื้อหน่วยลงทุน',

    // menu
    // not trust, etf
    'funddetailthmenu1': 'รายละเอียดกองทุน',
    'funddetailthmenu2': 'ผลการดำเนินงาน',
    'funddetailthmenu3': 'การซื้อขายหน่วยลงทุน',

    // is trust
    'funddetailthmenu4': 'รายละเอียดกองทรัสต์',
    'funddetailthmenu5': 'ผลการดำเนินงาน',
    'funddetailthmenu6': 'การซื้อขายหน่วยทรัสต์',
    'funddetailthmenu35': 'การซื้อขายหน่วยทรัสต์',

    // is etf
    'funddetailthmenu7': 'รายละเอียดกองทุน',
    'funddetailthmenu8': 'ผลการดำเนินงาน',
    'funddetailthmenu9': 'การซื้อขายหน่วยลงทุน',
    'funddetailthmenu10': 'ราคา/ตะกร้าหุ้น',

    // usd
    'funddetailthmenu11': 'Investment unit trading',
    'funddetailthmenu12': 'Price and PDF Report',
    'funddetailthmenu13': 'Unit Price (USD)',
    'funddetailthmenu14': 'As of',
    'funddetailthmenu15': 'Ask price/Switch to',
    'funddetailthmenu16': 'Ask price/Switch to',
    'funddetailthmenu17': 'Net Asset Value',
    'funddetailthmenu18': 'Dividend Payment Policy',
    'funddetailthmenu19': 'Unit Price',
    'funddetailthmenu20': 'Rewards',
    'funddetailthmenu21': 'Investment Objective',
    'funddetailthmenu22': 'Investment Focus',
    'funddetailthmenu23': 'Product Suitability',
    'funddetailthmenu24': 'Generald Information',
    'funddetailthmenu25': 'Fund Type',
    'funddetailthmenu26': 'Investment Policy',
    'funddetailthmenu27': 'Fund Code',
    'funddetailthmenu28': 'Registrar',
    'funddetailthmenu29': 'Fund Supervisor',
    'funddetailthmenu30': 'Inception Date',
    'funddetailthmenu31': 'Accounting Period',
    'funddetailthmenu32': 'Investment Portfolio',
    'funddetailthmenu33': 'Asset Allocation',
    'funddetailthmenu34': 'Top 5 Holdings',

    // menu 1
    // detail not trust, prop
    // block 1
    'funddetailthm1b1detail1': 'มูลค่าหน่วยลงทุน',
    'funddetailthm1b1detail2': 'ณ. วันที่',
    'funddetailthm1b1detail3': 'ราคาขาย/สับเปลี่ยนเข้า',
    'funddetailthm1b1detail4': 'ราคารับซื้อคืน/สับเปลี่ยนออก',
    'funddetailthm1b1detail5': 'มูลค่าทรัพย์สินสุทธิ',
    'funddetailthm1b1detail6': 'มูลค่าทรัพย์สินรวม',

    // block 2
    'funddetailthm1b2detail1': 'นโยบายการจ่ายเงินปันผล',

    // block 3
    'funddetailthm1b3detail1': 'มูลค่าหน่วยลงทุน',

    // block 4
    'funddetailthm1b4detail1': 'รางวัล',
    'funddetailthm1b4detail2': 'จุดประสงค์การลงทุน',
    'funddetailthm1b4detail3': 'สไตล์การลงทุน',
    'funddetailthm1b4detail4': 'เหมาะกับการนักลงทุนประเภทไหน',

    // block 7
    'funddetailthm1b7detail1': 'พอร์ตการลงทุน',
    'funddetailthm1b7detail1_asofdate': 'ข้อมูล ณ วันที่',
    'funddetailthm1b7detail2': 'การกระจายการลงทุน',
    'funddetailthm1b7detail3': 'ตราสารที่ลงทุนสูงสุด 5 อันดับแรก',

    // detail is trust
    // block 1
    'funddetailthm1b1detail7': 'มูลค่าหน่วยทรัสต์',
    'funddetailthm1b1detail8': 'ณ. วันที่',
    'funddetailthm1b1detail9': 'มูลค่าทรัพย์สินสุทธิ',
    'funddetailthm1b1detail10': 'มูลค่าทรัพย์สินรวม',

    // block 2
    'funddetailthm1b2detail2': 'นโยบายการจ่ายประโยชน์ตอบแทน',

    // detail is prop
    // block 1
    'funddetailthm1b1detail11': 'มูลค่าหน่วยลงทุน',
    'funddetailthm1b1detail12': 'ณ. วันที่',
    'funddetailthm1b1detail13': 'มูลค่าทรัพย์สินสุทธิ',
    'funddetailthm1b1detail14': 'มูลค่าทรัพย์สินรวม',

    // block 2
    'funddetailthm1b2detail3': 'นโยบายการจ่ายเงินปันผล',

    // block 5
    'funddetailthm1b5detail1': 'ข้อมูลทั่วไป',
    'funddetailthm1b5detail2': 'ประเภทกองทรัสต์',
    'funddetailthm1b5detail3': 'ประเภทกองทุน',
    'funddetailthm1b5detail4': 'นโยบายการลงทุน',
    'funddetailthm1b5detail5': 'รหัสกองทรัสต์',
    'funddetailthm1b5detail6': 'รหัสกองทุน',
    'funddetailthm1b5detail7': 'นายทะเบียน',
    'funddetailthm1b5detail8': 'ทรัสตี',
    'funddetailthm1b5detail9': 'ผู้ดูแลผลประโยชน์',
    'funddetailthm1b5detail10': 'วันเริ่มต้นโครงการ',
    'funddetailthm1b5detail11': 'รอบปีบัญชี',
    'funddetailthm1b5detail12': 'รอบระยะเวลาบัญชีสิ้นสุด',
    'funddetailthm1b5detail13': 'วันจัดตั้งกองทรัสต์',
    'funddetailthm1b5detail14': 'นโยบายการลงทุน',

    // block 6
    'funddetailthm1b6detail1': 'ดาวน์โหลดเอกสาร',

    // menu 2
    // detail not trust, prop
    // block 1
    'funddetailthm2b1detail1': 'ผลการดำเนินงานกองทุนย้อนหลัง',
    'funddetailthm2b1detail2': 'ตั้งแต่จัดตั้งกองทุน',

    // block 2
    'funddetailthm2b2detail1': 'มูลค่าหน่วยลงทุนย้อนหลัง 3 เดือน',
    // head table
    'funddetailthm2b2detail2': 'วันที่',
    'funddetailthm2b2detail3': 'NAV (THB/หน่วย)',
    'funddetailthm2b2detail4': 'ราคาขาย (THB/หน่วย)',
    'funddetailthm2b2detail5': 'ราคาซื้อคืน (THB/หน่วย)',
    'funddetailthm2b2detail6': 'มูลค่าทรัพย์สินสุทธิ(THB)',
    'funddetailthm2b2detail7': 'มูลค่าทรัพย์สินรวม (THB)',

    // detail is trust
    // block 2
    'funddetailthm2b3detail8': 'มูลค่าหน่วยทรัสต์ย้อนหลัง',
    // head table
    'funddetailthm2b2detail9': 'วันที่',
    'funddetailthm2b2detail10': 'NAV (THB/หน่วย)',
    'funddetailthm2b2detail11': 'มูลค่าทรัพย์สินสุทธิ(THB)',
    'funddetailthm2b2detail12': 'มูลค่าทรัพย์สินรวม (THB)',

    // detail is prop
    // block 2
    'funddetailthm2b3detail13': 'มูลค่าหน่วยลงทุน ตั้งแต่ตั้งกอง',
    // head table
    'funddetailthm2b2detail14': 'วันที่',
    'funddetailthm2b2detail15': 'NAV (THB/หน่วย)',
    'funddetailthm2b2detail16': 'มูลค่าทรัพย์สินสุทธิ(THB)',
    'funddetailthm2b2detail17': 'มูลค่าทรัพย์สินรวม (THB)',

    // detail is Deviden
    // block 2
    'funddetailthm2b3detail18': 'ประวัติการจ่ายเงินปันผล ตั้งแต่ตั้งกอง',
    'funddetailthm2b3detail19': 'ดาวน์โหลด',
    // head table 1
    'funddetailthm2b2detail20': 'วันที่',
    'funddetailthm2b2detail21': 'รหัสกองทุน',
    'funddetailthm2b2detail22': 'NAV (THB/หน่วย)',
    'funddetailthm2b2detail23': 'มูลค่าทรัพย์สินสุทธิ (THB)',
    'funddetailthm2b2detail24': 'มูลค่าทรัพย์สินรวม (THB)',

    // head table 2
    'funddetailthm2b2detail25': 'ครั้งที่',
    'funddetailthm2b2detail26': 'จำนวนเงินปันผล (บาท/หน่วยลงทุน)',
    'funddetailthm2b2detail27': 'วันที่ปิดสมุด',
    'funddetailthm2b2detail28': 'วันที่จ่าย',


    // new trust detail
    'funddetailthm2b3detail29': 'การจ่ายประโยชน์ตอบแทน',

    // block 3
    'funddetailthm2b3detail1': 'เครื่องคำนวณการลงทุน',
    'funddetailthm2b3detail2': 'เครื่องมือคํานวณ ที่จะช่วยให้คุณคํานวณเงินอย่างง่ายดาย รวดเร็ว และสะดวกสบายผลการดําเนินงานกองทุน',

    // block 4
    'funddetailthm2b4detail1': 'ผลการดำเนินงานกองทุน',
    'funddetailthm2b4detail2': 'ตรวจสอบผลการดำเนินงาน Fund Performance ของกองทุนได้ที่นี่',

    // menu 3
    // detail not trust, StoxxUSD, etf, prop
    // block 1
    'funddetailthm3b1detail1': 'การซื้อขายหน่วยลงทุน',
    'funddetailthm3b1detail2': 'การซื้อหน่วยลงทุน',
    'funddetailthm3b1detail3': 'มูลค่าขั้นต่ำของการซื้อครั้งแรก',
    'funddetailthm3b1detail4': 'บาท', // Baht
    'funddetailthm3b1detail5': 'มูลค่าขั้นต่ำของการซื้อครั้งถัดไป',
    'funddetailthm3b1detail6': 'Fund Gift Card ขั้นต่ำ',
    'funddetailthm3b1detail7': 'เวลาทำการ ซื้อ',
    // button
    'funddetailthm3b1detail8': 'เปิดบัญชีออนไลน์',
    'funddetailthm3b1detail9': 'ซื้อขายหน่วยลงทุนนี้',
    'funddetailthm3b1detail25': 'ดอลลาร์',

    // block 2
    'funddetailthm3b2detail1': 'การขายหน่วยลงทุน',
    'funddetailthm3b2detail2': 'จำนวนหน่วยลงทุนคงเหลือขั้นต่ำ',
    'funddetailthm3b2detail3': 'หน่วย',
    'funddetailthm3b2detail4': 'การขายคืน',
    'funddetailthm3b2detail5': 'มูลค่าเงินคงเหลือขั้นต่ำ',
    'funddetailthm3b2detail6': 'เวลาทำการขาย',
    'funddetailthm3b2detail7': 'วันรับเงินค่าขายคืน',
    'funddetailthm3b2detail8': 'ภายใน',
    'funddetailthm3b2detail9': 'วันทำการ',
    'funddetailthm3b2detail10': 'ถัดจากวันทำการขายคืน',

    // detail is etf
    // block 1
    'funddetailthm3b1detail10': 'วิธีการซื้อขาย',
    'funddetailthm3b1detail11': 'สำหรับผู้ร่วมค้าหน่วยลงทุน',
    'funddetailthm3b1detail12': 'สามารถสั่งซื้อหน่วยลงทุนโดยตรงกับบริษัทจัดการครั้งละไม่ต่ำกว่า 1 หน่วย และเพิ่มขึ้นเป็นทวีคูณ โดยใช้ราคา ณ วันทำการส่งคำสั่งซื้อหน่วยลงทุน ซึ่งใช้ตะกร้าหลักทรัพย์ ตามที่บริษัทจัดการกำหนด',
    'funddetailthm3b1detail13': 'สำหรับผู้ที่สนใจลงทุนทั่วไป',
    'funddetailthm3b1detail14': 'ผู้สนใจลงทุนทั่วไป หรือผู้ร่วมค้าหน่วยลงทุน สามารถซื้อหน่วยลงทุนของกองทุนในตลาดหลักทรัพย์แห่งประเทศไทย โดยปฏิบัติ ตามกฎ ระเบียบ และวิธีปฏิบัติของตลาดหลักทรัพย์ฯ และผู้สนใจลงทุนต้องมีบัญชีซื้อขายหลักทรัพย์กับบริษัทหลักทรัพย์ด้วย',
    'funddetailthm3b1detail15': 'โดยผู้ที่สนใจลงทุนทั่วไป สามารถซื้อหน่วยลงทุน ด้วยวิธีการส่งมอบตระกร้า หลักทรัพย์ โดยผ่านผู้ร่วมค้าหน่วยลงทุน',
    'funddetailthm3b1detail16': 'ตามขั้นตอนและวิธีการสั่งซื้อที่ผู้ร่วมค้า หน่วยลงทุนกำหนด',
    'funddetailthm3b1detail17': 'เวลาทำการซื้อขาย',
    'funddetailthm3b1detail18': 'ทุกวันทำการของตลาดหลักทรัพย์แห่งประเทศไทย',
    'funddetailthm3b1detail19': 'ไม่กำหนด',

    // detail is trust, prop
    // block 1
    'funddetailthm3b1detail20': 'วิธีการซื้อขาย',
    'funddetailthm3b1detail21': 'ผู้สนใจลงทุนทั่วไป หรือผู้ร่วมค้าหน่วยลงทุน สามารถซื้อหน่วยลงทุนของกองทุนในตลาดหลักทรัพย์แห่งประเทศไทย โดยปฏิบัติ ตามกฎ ระเบียบ และวิธีปฏิบัติของตลาดหลักทรัพย์ฯ และผู้สนใจลงทุนต้องมีบัญชีซื้อขายหลักทรัพย์กับบริษัทหลักทรัพย์ด้วย',
    'funddetailthm3b1detail22': 'โดยผู้ที่สนใจลงทุนทั่วไป สามารถซื้อหน่วยลงทุน ด้วยวิธีการส่งมอบตระกร้า หลักทรัพย์ โดยผ่านผู้ร่วมค้าหน่วยลงทุน',
    'funddetailthm3b1detail23': 'ตามขั้นตอนและวิธีการสั่งซื้อที่ผู้ร่วมค้า หน่วยลงทุนกำหนด',
    'funddetailthm3b1detail24': 'ผู้สนใจลงทุนทั่วไป หรือผู้ร่วมค้าหน่วยลงทุน สามารถซื้อหน่วยทรัสต์ของกองทรัสต์ในตลาดหลักทรัพย์แห่งประเทศไทย โดยปฏิบัติ ตามกฎ ระเบียบ และวิธีปฏิบัติของตลาดหลักทรัพย์ฯ และผู้สนใจลงทุนต้องมีบัญชีซื้อขายหลักทรัพย์กับบริษัทหลักทรัพย์ด้วย',

    // detail not trust, prop
    // block 3
    'funddetailthm3b3detail1': 'ค่าธรรมเนียมการซื้อขาย',
    'funddetailthm3b3detail2': 'ค่าธรรมเนียม',
    'funddetailthm3b3detail3': '(% ของมูลค่าหน่วยลงทุน)',

    'funddetailthm3b3detail4': 'ค่าธรรมเนียมการขาย',
    'funddetailthm3b3detail5': 'ค่าธรรมเนียมการรับซื้อคืน',
    'funddetailthm3b3detail6': 'ค่าธรรมเนียมการสับเปลี่ยนเข้า',
    'funddetailthm3b3detail7': 'ค่าธรรมเนียมการสับเปลี่ยนออก',

    'funddetailthm3b3detail8': 'ค่าธรรมเนียมที่เรียกเก็บจากกองทุน',
    'funddetailthm3b3detail9': '(% ของมูลค่าทรัพย์สินสุทธิของกองทุน รวม VAT)',
    'funddetailthm3b3detail10': 'ค่าธรรมเนียมนายทะเบียน',
    'funddetailthm3b3detail11': 'ค่าธรรมเนียมการจัดการ',
    'funddetailthm3b3detail12': 'ค่าธรรมเนียมผู้ดูแลผลประโยชน์',
    'funddetailthm3b3detail13': 'ค่าใช้จ่ายอื่นๆ',
    'funddetailthm3b3detail14': 'รวมค่าใช้จ่ายทั้งหมด',

    'funddetailthm3b3detail15': 'ค่าธรรมเนียม',
    'funddetailthm3b3detail16': 'ค่าธรรมเนียมที่เรียกเก็บจากกองทรัสต์',
    'funddetailthm3b3detail17': '(% มูลค่าทรัพย์สินรวมของกองทรัสต์ ไม่รวม VAT)',
    'funddetailthm3b3detail18': 'ค่าธรรมเนียมนายทะเบียน',
    'funddetailthm3b3detail19': 'ค่าธรรมเนียมการจัดการ',
    'funddetailthm3b3detail20': 'ค่าธรรมเนียมผู้ดูแลผลประโยชน์',
    'funddetailthm3b3detail21': 'ค่าใช้จ่ายอื่นๆ',
    'funddetailthm3b3detail22': 'รวมค่าใช้จ่ายทั้งหมด',

    'funddetailthm3b3detail23': 'ค่าธรรมเนียมการซื้อขาย',
    'funddetailthm3b3detail24': 'ค่าธรรมเนียมที่เรียกเก็บจากกองทุน',
    'funddetailthm3b3detail25': '(% มูลค่าทรัพย์สินรวมของกองทุน รวม VAT)',
    'funddetailthm3b3detail26': 'ค่าธรรมเนียมนายทะเบียน',
    'funddetailthm3b3detail27': 'ค่าธรรมเนียมการจัดการ',
    'funddetailthm3b3detail28': 'ค่าธรรมเนียมผู้ดูแลผลประโยชน์',
    'funddetailthm3b3detail29': 'ค่าใช้จ่ายอื่นๆ',
    'funddetailthm3b3detail30': 'รวมค่าใช้จ่ายทั้งหมด',

    // block 4
    'funddetailthm3b4detail1': 'ปฏิทินวันทำรายการซื้อขาย/วันหยุดกองทุน',

    // block 5
    'funddetailthm3b5detail1': 'ช่องทางการซื้อขาย',
    'funddetailthm3b5detail2': 'คุณสามารถซื้อขายกองทุนผ่านช่องทางดังต่อไปนี้',
    'funddetailthm3b5detail3': 'สามารถซื้อขายได้โดยติดต่อเปิดบัญชีซื้อขายหลักทรัพย์กับบริษัทหลักทรัพย์',

    // detail not openTop, trust, prop
    'funddetailthm3b5detail4': 'บริการซื้อขายออนไลน์',
    'funddetailthm3b5detail5': 'ง่ายนิดเดียว',
    'funddetailthm3b5detail6': 'บลจ. วรรณ',
    'funddetailthm3b5detail7': 'ติดต่อโทร',

    // block 6
    // detail is hasSupporter
    'funddetailthm3b6detail1': 'ผู้สนับสนุนการขาย หรือรับ',
    'funddetailthm3b6detail2': 'ซื้อคืนหน่วยลงทุน',

    // menu 4
    // is etf
    'funddetailthm4detail1': 'ราคา',
    'funddetailthm4detail2': 'ณ. วันที่',
    'funddetailthm4detail3': 'จำนวนหุ้น',
    'funddetailthm4detail4': 'ข้อมูล ณ วันที่',
    'funddetailthm4detail5': 'ดาวน์โหลด PDF',
    'funddetailthm4detail6': 'ดาวน์โหลด BA/NAV',
    'funddetailthm4detail7': 'หุ้น',
    'funddetailthm4detail8': 'ราคาซื้อคืน',
    'funddetailthm4detail9': '(บาท/หน่วย)',
    'funddetailthm4detail10': 'จำนวน (บาท)',
    'funddetailthm4detail11': 'มูลค่าของ PDF เป็นมูลค่าของ TDEX จำนวน 1 C.U. (Creation Unit) หรือ เท่ากับ 1,000,000 หน่วย',

    // sumModal
    'funddetailthsummodal1': 'คำเตือน',
    'funddetailthsummodal2': 'ผลการดำเนินงานในอดีตของกองทุนรวม มิได้เป็นสิ่งยืนยันถึงผลการดำเนินงานในอนาคต',
    'funddetailthsummodal3': 'การวัดผลการดำเนินงานของกองทุนรวมฉบับนี้ ได้จัดทำขึ้นตามมาตรฐานการวัดผลการดำเนินงานที่กำหนดโดยสมาคมบริษัทจัดกาลงทุน',
    'funddetailthsummodal4': 'การคำนวณอัตราผลตอบแทนดังกล่าวคำนวณโดยไม่ได้หักค่าธรรมเนียมการซื้อขายหน่วยลงทุน',
    'funddetailthsummodal5': 'แสดงผลตอบแทนเป็น Annualized ถ้ามากกว่า 1 ปี',
    'funddetailthsummodal6': 'ความถี่ในการปรับน้ำหนักของ Composite Benchmark คำนวณเป็นรายวัน',
    'funddetailthsummodal7': 'การคำนวณ Standard deviation ของกองทุน และตาราง Standard deviation ของเกณฑ์มาตรฐาน หากตั้งกองทุนมากกว่า 3 ปี ใช้ความถี่รายเดือน ถ้าน้อยกว่า 3 ปีให้ใช้รายวัน',
    'funddetailthsummodal8': 'การลงทุนในหน่วยลงทุนของกองทุนรวมตลาดเงินไม่ใช่การฝากเงิน และมีความเสี่ยงจากการลงทุน ซึ่งผู้ลงทุนอาจไม่ได้รับเงินลงทุนคืนเต็มจำนวน',

    // Corporate Governance (cg)
    // menu
    'cgmenu1': 'นโยบายธรรมาภิบาลการลงทุน',
    'cgmenu2': 'จรรยาบรรณ',
    'cgmenu3': 'นโยบายต่อต้านคอร์รัปชั่น',
    'cgmenu4': 'หลักธรรมาภิบาลเกี่ยวกับผลิตภัณฑ์กองทุนรวม',

    // detail
    'cgdetail': 'ดาวน์โหลด PDF',

    // Investment Management Supervision (ims)
    // menu
    'imsmenu1': 'รายชื่อผู้จัดการกองทุน',
    'imsmenu2': 'รายงานธุรกรรมกับบุคคลที่เกี่ยวข้อง',
    'imsmenu3': 'แนวทางการใช้สิทธิออกเสียงในที่ประชุมผู้ถือหุ้น',
    'imsmenu4': 'รายงานสรุปเกี่ยวกับการใช้สิทธิออกเสียง',
    'imsmenu5': 'รายงานการถือหน่วยลงทุนเกิน 1 ใน 3',
    'imsmenu6': 'รายชื่อบุคลากรที่ได้รับมอบหมายให้แนะนำการลงทุนผ่านสื่อหรืองานสัมมนา',

    // detail
    'imsdetail': 'ดาวน์โหลด PDF',

    // Job Detail
    // header
    'jobdetailheader': 'รายละเอียด',

    // title
    'jobdetailtitle1': 'รายละเอียดงาน',
    'jobdetailtitle2': 'คุณสมบัติผู้สมัคร',
    'jobdetailtitle3': 'ติดต่อสมัครงาน',

    // address
    'jobdetailaddress1': 'บริษัทหลักทรัพย์จัดการกองทุน วรรณ จำกัด',
    'jobdetailaddress2': 'อาคารสยามพิวรรธน์ทาวเวอร์ ชั้น 9, 24',
    'jobdetailaddress3': 'ถนนพระราม 1 แขวงปทุมวัน เขตปทุมวัน กรุงเทพฯ 10330',
    'jobdetailaddress4': 'โทรศัพท์: 02-659-8738, 8743, 8741',

    // Job
    // header
    'jobheader': 'กรอกข้อมูล',

    // title icon
    'jobtitleicon1': 'ประวัติส่วนตัว',
    'jobtitleicon2': 'ประวัติการศึกษา',
    'jobtitleicon3': 'ข้อมูลครอบครัว',
    'jobtitleicon4': 'ประวัติการทำงาน',

    // error
    'joberror1': 'กรุณากรอกข้อมูล',
    'jobeduwarning1': 'ขนาดไม่เกิน 500 Mb.',
    'jobeduwarning2': 'หากไม่มีข้อมูลเติมเครื่องหมาย',
    'jobeduwarning3': 'ลบไฟล์',

    // button
    'jobbtn1': 'เพิ่มชุดข้อมูล',
    'jobbtn2': 'ลบ',
    'jobbtn3': 'แนบไฟล์',
    'jobbtn4': 'อัพโหลด',
    'jobbtn5': 'ถัดไป',
    'jobbtn6': 'ย้อนกลับ',
    'jobbtn7': 'ยืนยันส่งข้อมูล',
    'jobnumber': 'ชุดที่',
    'jobchoose': 'เลือก',

    // Job personal title
    'jobpersonaltitle1': 'นาย',
    'jobpersonaltitle2': 'นาง',
    'jobpersonaltitle3': 'นางสาว',
    'jobpersonaltitle4': 'ด.ช.',
    'jobpersonaltitle5': 'ด.ญ.',

    // Job Apply
    // header
    'jobapplyheader': 'กรอกข้อมูล',

    // personal infomation
    'jobapplypersoninfo1': 'คำนำหน้า',
    'jobapplypersoninfo2': 'ชื่อ',
    'jobapplypersoninfo3': 'นามสกุล',
    'jobapplypersoninfo4': 'เงินเดือนที่คาดหวัง',

    // Job Education
    // Background
    // Laveleducation
    'jobedulevel': 'ระดับการศึกษา',
    'jobedulevel1': 'ปริญญาโท',
    'jobedulevel2': 'ปริญญาตรี',
    'jobedulevel3': 'อื่น ๆ',
    'jobedulevel4': 'มัธยมศึกษา/อาชีวะศึกษา',

    // year academic
    'jobeduacademicyear': 'ปีการศึกษา',

    // uni
    'jobeduuni': 'ชื่อสถาบัน',
    'jobedusection': 'สาขาวิชาเอก',

    // date
    'jobedufrom': 'ตั้งแต่',
    'jobeduto': 'ถึง',

    // error
    'jobeduerror1': 'กรุณาเลือกข้อมูล',

    // Language
    'jobedutest': 'แนบผลสอบวัดระดับภาษา',
    'jobedutestresult1': 'การพูด',
    'jobedutestresult2': 'ความเข้าใจ',
    'jobedutestresult3': 'การอ่าน',
    'jobedutestresult4': 'การเขียน',

    // License
    'jobedulicense': 'ชื่อใบอนุญาต',
    'jobedulicenseno': 'เลขที่ใบอนุญาต',
    'jobedulicensedate': 'วันที่หมดอายุ',

    // Skill
    'jobeducomputerprogram': 'ความสามารถพิเศษโปรแกรมคอมพิวเตอร์',
    'jobedutalent': 'ความสามารถพิเศษอื่น ๆ',
    'jobeduskill1': 'ดีมาก',
    'jobeduskill2': 'ดี',
    'jobeduskill3': 'พอใช้',

    // Month
    'month1': 'ม.ค.',
    'month2': 'ก.พ.',
    'month3': 'มี.ค.',
    'month4': 'เม.ย.',
    'month5': 'พ.ค.',
    'month6': 'มิ.ย.',
    'month7': 'ก.ค.',
    'month8': 'ส.ค.',
    'month9': 'ก.ย.',
    'month10': 'ต.ค.',
    'month11': 'พ.ย.',
    'month12': 'ธ.ค.',

    // Job Family
    // Status
    'jobfamstatus1': 'สถานภาพการสมรส',

    // detail
    'jobfamdetail1': 'รายละเอียดครอบครัว',
    'jobfamdetail2': 'บิดา',
    'jobfamdetail3': 'มารดา',
    'jobfamdetail4': 'พี่/น้อง',
    'jobfamdetail5': 'สามี/ภรรยา',
    'jobfamdetail6': 'โสด',
    'jobfamdetail7': 'สมรส',
    'jobfamdetail8': 'ม่าย',
    'jobfamdetail9': 'หย่า',
    'jobfamdetail10': 'บุคคลที่สามารถติดต่อได้กรณีเร่งด่วน',

    'jobfamtitle1': 'คำนำหน้า',
    'jobfamtitle2': 'ชื่อ',
    'jobfamtitle3': 'นามสกุล',
    'jobfamtitle4': 'อายุ',
    'jobfamtitle5': 'โทรศัพท์',
    'jobfamtitle6': 'อาชีพ',
    'jobfamtitle7': 'ที่อยู่',
    'jobfamtitle8': 'ความสัมพันธ์',
    'jobfamtitle9': 'หมายเลขโทรศัพท์',
    'jobfamtitle10': 'ชื่อ',
    'jobfamtitle11': 'นามสกุล',

    // Job Experience
    'jobexptest': 'แนบประวัติการทำงาน',
    'jobexpdetail1': 'หน้าที่ความรับผิดชอบ',
    'jobexpdetail2': 'ตัวอักษร',

    // Job Comfirm
    'jobcomfirmdetail1': 'ข้อมูลอื่น ๆ',
    'jobcomfirmdetail2': 'บุคคลที่',
    'jobcomfirmdetail3': 'ท่านเป็นบุคคลไม่สมประกอบ พิการ หรือ เป็นโรคติดต่อร้ายแรงมาก่อนหรือไม่',
    'jobcomfirmdetail4': 'ถ้าเป็น กรุณาระบุ',
    'jobcomfirmdetail5': 'ท่านเคยถูกจับกุม หรือถูกสอบสวน หรือถูกฟ้องร้อง หรือถูกลงโทษฐานกระทำผิดทางอาญาหรือไม่',
    'jobcomfirmdetail6': 'ท่านเคยถูกไล่ออก หรือถูกเลิกจ้าง โดยมีความผิดมาก่อนหรือไม่',
    'jobcomfirmdetail7': 'ท่านเคยทำงานกับบริษัทหลักทรัพย์จัดการกองทุน วรรณ จำกัด มาก่อนหรือไม่?',
    'jobcomfirmdetail8': 'กรุณาระบุผู้ที่จะอ้างถึง 2 ท่าน ที่รู้จักคุ้นเคยตัวท่านดี',
    'jobcomfirmdetail9': 'ข้าพเจ้าขอรับรองว่าข้อความดังกล่าวทั้งหมดในใบสมัครนี้เป็นความจริงถูกต้องและสมบูรณ์ทุกประการ และข้าพเจ้าขอยืนยันว่าข้อมูลส่วนบุคคลของบุคคลอ้างอิงหรือบุคคลใดก็ตามที่ข้าพเจ้าระบุไว้ในใบสมัครนี้ ข้าพเจ้าได้รับความยินยอมจากบุคคลดังกล่าวแล้วก่อนจะมอบข้อมูลส่วนบุคคลนั้นให้กับบริษัท ทั้งนี้ ภายหลังจากบริษัทได้ว่าจ้างข้าพเจ้าเข้ามาทำงานแล้ว หากปรากฎว่าข้อความในใบสมัครงาน และ/หรือ เอกสารที่ข้าพเจ้านำมาแสดง หรือให้ไว้กับบริษัทไม่เป็นความจริง ข้าพเจ้ายินยอมให้บริษัทเลิกจ้างข้าพเจ้าได้โดยไม่ต้องจ่ายเงินชดเชยหรือค่าเสียหายใดๆ ทั้งสิ้น',
    'jobcomfirmdetail10': 'กรุณารับรองความถูกต้องของข้อมูล\nในใบสมัครงานก่อนกด "ยืนยัน"',
    'jobcomfirmdetail11': 'หนังสือให้ความยินยอมในการเก็บ รวบรวม ใช้ และ/หรือเปิดเผยข้อมูลส่วนบุคคล',
    'jobcomfirmdetail12': 'ข้าพเจ้าได้ให้ความยินยอมแก่บริษัทหลักทรัพย์จัดการกองทุน วรรณ จำกัด (“บริษัท”) ในการเก็บรวบรวม ใช้ และ/  หรือ เปิดเผยข้อมูลส่วนบุคคลของข้าพเจ้า ซึ่งรวมถึงข้อมูลอ่อนไหวของข้าพเจ้า ตามพระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล พ.ศ. 2562 (และตามที่ได้มีการแก้ไขเพิ่มเติม รวมถึงประกาศที่ออกตามพระราชบัญญัติดังกล่าว) และ นโยบายคุ้มครองข้อมูลส่วนบุคคลของบริษัท และข้าพเจ้ายืนยันว่าข้อมูลที่ข้าพเจ้าได้ให้แก่บริษัทมีความถูกต้อง เป็นปัจจุบัน สมบูรณ์ และไม่ก่อให้เกิดความเข้าใจผิด โดยมีรายละเอียดดังต่อไปนี้ ทั้งนี้ คำนิยามที่กำหนดไว้ในนโยบายคุ้มครองข้อมูลส่วนบุคคลของบริษัท จะมีความหมายเช่นเดียวกันเมื่อใช้ในเอกสารฉบับนี้ เว้นแต่จะได้นิยามไว้เป็นอย่างอื่นในเอกสารฉบับนี้',
    'jobcomfirmdetail13': 'ข้าพเจ้ายินยอมให้บริษัทเก็บ รวบรวม ใช้ และ/หรือ เปิดเผยข้อมูลอ่อนไหว ได้แก่ ข้อมูลศาสนา สุขภาพ ความพิการ ประวัติอาชญากรรม ประวัติการถูกลงโทษจากหน่วยงานกำกับดูแล และข้อมูลการกระทำความผิดทั้งทางแพ่งและ อาญา รวมถึงข้อมูลที่จำเป็นอื่นๆ ตามข้อบังคับของหน่วยงานที่กำกับดูแล เช่น สำนักงานคณะกรรมการกำกับหลักทรัพย์และตลาดหลักทรัพย์ สำนักงานป้องกันและปราบปรามการฟอกเงินซึ่งเป็นส่วนหนึ่งของขั้นตอนการ พิจารณาสรรหาคัดเลือกพนักงานและการว่าจ้างเพื่อปฏิบัติงานในตำแหน่งใดๆ',
    'jobcomfirmdetail14': 'ข้าพเจ้ารับทราบนโยบายข้อมูลส่วนบุคคลของบริษัทรวมถึงสิทธิในการเพิกถอนความยินยอมตามนโยบายคุ้มครองข้อมูลส่วนบุคคลของบริษัทหรือตามช่องทางสื่อสารอื่นใดของบริษัทแล้ว จึงได้ลงลายมือชื่อไว้เป็นหลักฐาน',
    'jobcomfirmdetail15': 'ท่านสามารถตรวจสอบนโยบายความเป็นส่วนตัว (Privacy Policy) ที่ ',
    'jobcomfirmdetail15_2': 'https://www.one-asset.com/privacy-notice',
    'jobcomfirmdetail15_3': ' เพื่อทราบรายละเอียดเกี่ยวกับการจัดเก็บ ใช้ และเปิดเผยข้อมูลส่วนตัวของท่าน รวมถึงสิทธิต่าง ๆ ที่ท่านมีอยู่ตามพระราชบัญญัติคุ้มครองส่วนบุคคล พ.ศ. 2562 ในกรณีที่ท่านประสงค์ที่จะถอนความยินยอมหรือมีข้อสงสัยดังกล่าวข้างต้น สามารถติดต่อบริษัทหลักทรัพย์จัดการกองทุน วรรณ จำกัด โทร 02-659-8888',
    'jobcomfirmdetail16': 'หมายเหตุ',

    // Job
    'jobapplytiltle1': 'ประวัติส่วนตัว',
    'jobapplytiltle2': 'ประวัติการศึกษา',

    'jobapplydetail1': 'โทรศัพท์บ้าน',
    'jobapplydetail2': 'มือถือ',
    'jobapplydetail3': 'อีเมล์',
    'jobapplydetail4': 'วัน/เดือน/ปีเกิด',
    'jobapplydetail5': 'อายุ',
    'jobapplydetail6': 'บัตรประชาชนเลขที่',
    'jobapplydetail7': 'สัญชาติ',
    'jobapplydetail8': 'ศาสนา',
    'jobapplydetail9': 'ภูมิลำเนา',
    'jobapplydetail10': 'ที่อยู่ที่ติดต่อได้',
    'jobapplydetail11': '(เดือน/ปี)',
    'jobapplydetail12': 'เกรดเฉลี่ย',
    'jobapplydetail13': 'ความสามารถด้านภาษา',
    'jobapplydetail14': 'ภาษา',
    'jobapplydetail15': 'ใบอนุญาตต่างๆ',
    'jobapplydetail16': 'ข้อมูลครอบครัว',
    'jobapplydetail17': 'จำนวนบุตร',
    'jobapplydetail18': 'ประวัติการทำงาน',
    'jobapplydetail19': 'ระยะเวลา (เดือน/ปี)',
    'jobapplydetail20': 'ตั้งแต่',
    'jobapplydetail21': 'ถึง',
    'jobapplydetail22': 'นายจ้าง / บริษัท',
    'jobapplydetail23': 'ตำแหน่ง',
    'jobapplydetail24': 'บุคคลอ้างอิง',
    'jobapplydetail25': 'ความสัมพันธ์',
    'jobapplydetail26': 'อายุคนที่',
    'jobapplydetail27': 'สถานภาพทางทหาร',
    'jobapplydetail28': 'ได้รับยกเว้น',
    'jobapplydetail29': 'ยังไม่ผ่านการเกณฑ์ทหาร',
    'jobapplydetail30': 'เรียนรักษาดินแดน',
    'jobapplydetail31': 'รับราชการทหารแล้ว',
    'jobapplydetail32': 'ที่อยู่ตามทะเบียนบ้าน',
    'jobapplydetail33': 'อบรม/สัมมนา',
    'jobapplydetail34': 'ชื่อหัวข้อ',
    'jobapplydetail35': 'สถาบันฝึกอบรม',
    'jobapplydetail36': 'ระยะเวลา',
    'jobapplydetail37': 'ปีสมรส (พ.ศ.)',
    'jobapplydetail38': 'วันที่พร้อมร่วมงาน',
    'jobapplydetail39': 'งานอดิเรก กีฬา กิจกรรมที่สนใจ',
    'jobapplydetail40': 'สาเหตุที่ลาออก',
    'jobapplydetail41': 'ท่านมีรถยนต์ส่วนตัวที่ใช้เป็นยานพหนะเดินทางหรือไม่?',
    'jobapplydetail42': 'รถยนต์',
    'jobapplydetail43': 'ท่านมีรถจักรยานยนต์ส่วนตัวที่ใช้เป็นยานพหนะเดินทางหรือไม่?',
    'jobapplydetail44': 'มี',
    'jobapplydetail45': 'ไม่มี',
    'jobapplydetail46': 'ประเภทใบอนุญาต',
    'jobapplydetail47': 'ชั่วคราว',
    'jobapplydetail48': 'ตลอดชีพ',
    'jobapplydetail49': 'ท่านทราบข่าวรับสมัครงานจากแหล่งใด?',
    'jobapplydetail50': 'www.one-asset.com',
    'jobapplydetail51': 'Website สมัครงาน',
    'jobapplydetail52': 'พนักงาน บลจ.วรรณ',
    'jobapplydetail53': 'โปรดระบุ',
    'jobapplydetail54': 'กรุณาแนะนำตัวท่านเอง เพื่อให้บริษัทฯรู้จักท่านดีขึ้น',
    'jobapplydetail55': 'บุตร/ธิดา',
    'jobapplydetail56': 'ใช่',
    'jobapplydetail57': 'ไม่ใช่',
    'jobapplydetail58': 'มี',
    'jobapplydetail59': 'ไม่มี',
    'jobapplydetail60': 'เงินเดือนเริ่ม',
    'jobapplydetail61': 'เงินเดือนสิ้นสุด',

    'jobapplydetailerror1': 'กรุณากรอกอีเมลให้ถูกต้อง',
    'jobapplydetailerror2': 'โปรดระบุ',
    'jobapplydetailerror3': 'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง',

    // Fund Compare
    'fundcompare1': 'เปรียบเทียบกองทุน',
    'fundcompare2': 'กองทุนที่ 1',
    'fundcompare3': 'กองทุนที่ 2',
    'fundcompare4': 'เลือกกองทุน',
    'fundcompare5': 'กรุณาเลือกกองทุน',
    'fundcompare6': 'ดูรายละเอียด',
    'fundcompare7': '(หากตรงกับวันหยุดทำการ',
    'fundcompare8': 'ให้เลื่อนไปเป็นวันทำการถัดไป)',
    'fundcompare9': 'ภายในเวลา 15.00 น.',

    // Search page
    'searchpage1': 'ผลการค้นหา',
    'searchpage2': 'กองทุน',
    'searchpage3': 'มูลค่าหน่วยลงทุน',
    'searchpage4': 'ข่าวสาร',
    'searchpage5': 'ประกาศ',
    'searchpage6': 'Earth Update',
    'searchpage7': 'กองทุนแนะนำ',
    'searchpage8': 'โปรโมชั่น',
    'searchpage9': 'สิทธิประโยชน์',


    // btn
    'btn1': 'ปฏิเสธ',
    'btn2': 'ยอมรับ',
    'btn3': 'ก่อนหน้า',
    'btn4': 'ถัดไป',
    'btn5': 'คำนวณ',
    'btn6': 'ลบ',
    'btn7': 'Apply',

    // Disclaimer Main Page
    'disclaimer1': 'คำเตือน',
    'disclaimer2': 'ผลการดำเนินงานในอดีตของกองทุนรวม มิได้เป็นสิ่งยืนยันถึงผลการดำเนินงานในอนาคต',
    'disclaimer3': 'การวัดผลการดำเนินงานของกองทุนรวมฉบับนี้ ได้จัดทำขึ้นตามมาตรฐานการวัดผลการดำเนินงานที่กำหนดโดยสมาคมบริษัทจัดกาลงทุน',
    'disclaimer4': 'การคำนวณอัตราผลตอบแทนดังกล่าวคำนวณโดยไม่ได้หักค่าธรรมเนียมการซื้อขายหน่วยลงทุน',
    'disclaimer5': 'แสดงผลตอบแทนเป็น Annualized ถ้ามากกว่า 1 ปี',
    'disclaimer6': 'ความถี่ในการปรับน้ำหนักของ Composite Benchmark คำนวณเป็นรายวัน',
    'disclaimer7': 'การคำนวณ Standard deviation ของกองทุน และตาราง Standard deviation ของเกณฑ์มาตรฐาน หากตั้งกองทุนมากกว่า 3 ปี ใช้ความถี่รายเดือน ถ้าน้อยกว่า 3 ปีให้ใช้รายวัน',
    'disclaimer8': 'การลงทุนในหน่วยลงทุนของกองทุนรวมตลาดเงินไม่ใช่การฝากเงิน และมีความเสี่ยงจากการลงทุน ซึ่งผู้ลงทุนอาจไม่ได้รับเงินลงทุนคืนเต็มจำนวน',

    // Asset Allocation
    // NEW INVESTOR
    'allocation1': 'สรุปผลลัพธ์การประเมิน',
    'allocation2': 'คุณได้คะแนน',
    'allocation3': 'คุณเป็นนักลงทุนประเภท',
    'allocation4': 'คุณสามารถลงทุนในตราสารประเภท',
    'allocation5': 'พอร์ตการลงทุน',
    'allocation9': 'ที่แนะนำ',
    'allocation6': 'โอกาสผลตอบแทนสูงกว่าเงินฝาก เหมาะสำหรับผู้ลงทุนอายุ',
    'allocation7': 'หรือรับความเสี่ยงการขาดทุนได้',
    'allocation8': 'ทำแบบทดสอบการรับความเสี่ยงอีกครั้ง',

    // investorType
    'allocation10': 'ความเสี่ยงต่ำ',
    'allocation11': 'ความเสี่ยงปานกลางค่อนข้างต่ำ',
    'allocation12': 'ความเสี่ยงปานกลางค่อนข้างสูง',
    'allocation13': 'ความเสี่ยงสูง',
    'allocation14': 'ความเสี่ยงสูงมาก',

    // investment
    'allocation15': 'ตราสารหนี้ / ตราสารทุนเพียงเล็กน้อย / หน่วยลงทุนที่มีระดับความเสี่ยง 1',
    'allocation16': 'ตราสารหนี้ / ตราสารทุนบางส่วน / หน่วยลงทุนที่มีระดับความเสี่ยง 1-4',
    'allocation17': 'ตราสารหนี้ / ตราสารทุนบางส่วน-ปานกลาง / หน่วยลงทุนที่มีระดับความเสี่ยง 1-5',
    'allocation18': 'ตราสารหนี้ / ตราสารทุนปานกลาง / หน่วยลงทุนที่มีระดับความเสี่ยง 1-7',
    'allocation19': 'ตราสารหนี้ / ตราสารทุนค่อนข้างมาก / หน่วยลงทุนที่มีระดับความเสี่ยง 1-8',

    // recommRisk
    'allocation20': 'ความเสี่ยงต่ำ',
    'allocation21': 'ความเสี่ยงปานกลาง',
    'allocation22': 'ความเสี่ยงสูง',

    // riskLevel
    'allocation23': 'ต่ำ',
    'allocation24': 'กลาง',
    'allocation25': 'สูง',

    // INVESTMENT TARGET
    'allocation26': 'ขั้นที่ 2: ประเมินความเสี่ยง',
    'allocation27': 'เป้าหมายเงินออม',
    'allocation28': 'บาท',
    'allocation29': 'เป้าหมายเงินออมต้องมีค่ามากกว่า 0',
    'allocation30': 'เงินออมปัจจุบัน',
    'allocation31': 'ระยะเวลาลงทุนเพื่อเป้าหมาย',
    'allocation32': 'ปี',
    'allocation33': 'ระยะเวลาลงทุนเพื่อเป้าหมายต้องมากกว่า 0 ปี',

    'allocation34': 'ขั้นที่ 3: ความเสี่ยงที่คุณยอมรับได้',
    'allocation35': 'ระดับความเสี่ยงที่ยอมรับได้',

    // RETIREMENT
    'allocation36': 'ขั้นที่ 2: สำรวจเงินออมของคุณ',
    'allocation37': 'ปัจจุบันอายุ',
    'allocation38': 'ปี',
    'allocation39': 'อายุปัจจุบันต้องมากกว่า 0',
    'allocation40': 'เงินออมปัจจุบัน',
    'allocation41': 'บาท',
    'allocation42': 'จะเกษียณตอนอายุ',
    'allocation43': 'อายุเกษียณต้องมากกว่า 0 และมากกว่าอายุปัจจุบัน',
    'allocation44': 'อายุขัย',
    'allocation45': 'อายุขัยต้องมากกว่า 0 และมากกว่าอายุเกษียณ',
    'allocation46': 'ค่าใช้จ่ายหลังเกษียณ',
    'allocation47': 'บาท/เดือน',
    'allocation48': 'ค่าใช้จ่ายหลังเกษียณต้องมากกว่า 0',

    'allocation49': 'ขั้นที่ 3: ความเสี่ยงที่คุณยอมรับได้',
    'allocation50': 'ระดับความเสี่ยงที่ยอมรับได้',

    // FUND
    'direct_debit1': 'ช่องทางการสมัครบริการหักบัญชีอัตโนมัติ (Direct Debit) ',
    'direct_debit1_1': 'มี 4 ช่องทางดังนี',
    'direct_debit2': 'สมัครผ่านตู้ ATM',
    'direct_debit3': 'สมัครผ่าน Mobile Application',
    'direct_debit4': 'สมัครผ่าน Website ของธนาคาร',
    'direct_debit5': 'สมัครโดยกรอกแบบฟอร์มหนังสือยินยอมให้หักบัญชีเงินฝาก ยื่นต่อเจ้าหน้าที่ฝ่ายลูกค้าสัมพันธ์และสนับสนุนธุรกิจของบริษัท เมื่อทางบริษัท ได้รับอนุมัติจากธนาคารเจ้าของบัญชีเรียบร้อยแล้ว ทางบริษัทจะแจ้งให้ท่านทราบต่อไป โดยขั้นตอนนี้จะใช้เวลาประมาณ 1 เดือน',
    'direct_debit6': 'ในส่วนของการสมัคร การสั่งซื้อหน่วยลงทุนแบบสม่ำเสมอ (Standing Instruction) มี 3 ช่องทาง',
    'direct_debit7': 'สมัครผ่าน Mobile Application : ONEAM',
    'direct_debit8': 'สมัครผ่าน One Live',
    'direct_debit9': 'สมัครโดยกรอกแบบฟอร์มใบคำสั่งซื้อหน่วยลงทุนอัตโนมัติ',
    'direct_debit10': 'หมายเหตุ : ปัจจุบัน ทางบริษัทจะทำการหักบัญชีอัตโนมัติทุกวันที่ 1 และ 16 ของเดือนเท่านั้น',

    // customer service
    'cs_title': 'ส่วนบริการลูกค้า',
    'cs_pid_title': 'กรุณากรอกข้อมูลเพื่อจัดการความยินยอม และขอใช้สิทธิของเจ้าของข้อมูลส่วนบุคคล (ลูกค้าปัจจุบันเท่านั้น)',
    'cs_pid_title2': 'ลูกค้าชาวต่างชาติโปรดติดต่อ ฝ่ายลูกค้าสัมพันธ์และสนับสนุนธุรกิจ โทร 02-659-8888 กด 1',
    'cs_pid': 'กรุณากรอกเลขประจำตัวประชาชน / เลขหนังสือเดินทาง',
    'cs_login': 'ส่ง',
    'cs_otp_title': 'ระบบได้ส่ง OTP ไปยังเบอร์โทรศัพท์หมายเลข ',
    'cs_otp_title2': ' โปรดกรอก OTP ที่ได้รับ',
    'cs_otp': 'กรุณากรอก OTP',
    'cs_request_otp': 'ขอ OTP อีกครั้ง',
    'cs_consent': 'การจัดการความยินยอม',
    'cs_dsar': 'การขอใช้สิทธิเจ้าของข้อมูลส่วนบุคคล',

    'cs_edoc': 'บริการอิเล็กทรอนิกส์สำหรับลูกค้าปัจจุบัน',

    // tax consent
    'tax_header': 'แจ้งความประสงค์จะใช้สิทธิขอยกเว้นภาษีเงินได้จากการลงทุนในกองทุนรวมเพื่อการออม กองทุนรวมเพื่อการเลี้ยงชีพ หรือกองทุนรวมอื่นใดที่อาจใช้สิทธิยกเว้นภาษีเงินได้ (ต่อไปนี้รวมเรียกว่า "กองทุนรวมที่สามารถใช้สิทธิลดหย่อนภาษีได้")',
    'tax_select_year': 'กรุณาเลือกปีภาษีที่ประสงค์ใช้สิทธิยกเว้นภาษีเงินได้ เพื่อหักลดหย่อนเงินได้จากการลงทุนในกองทุนรวมเพื่อการออม กองทุนรวมเพื่อการเลี้ยงชีพ หรือกองทุนรวมอื่นใดที่อาจใช้สิทธิยกเว้นภาษีเงินได้',
    'tax_dropdown_header': 'กรุณาเลือกปี',
    'tax_dropdown_footer': 'เป็นต้นไป',
    'tax_remark': 'หมายเหตุ :',
    'tax_remark1': '1. ข้าพเจ้ารับทราบว่าข้อมูลการแจ้งความประสงค์และให้ความยินยอมในครั้งนี้ เป็นการแจ้งความประสงค์เพียงครั้งเดียว โดยจะมีผลตลอดปีภาษี <b>2565</b> เป็นต้นไป จนกว่าข้าพเจ้าแจ้งเปลี่ยนความประสงค์เป็นอย่างอื่น ทั้งนี้บริษัทฯ จะยึดข้อมูลการแจ้งความประสงค์ตามวันที่ล่าสุดที่ข้าพเจ้าให้ไว้',
    'tax_remark2': '2. โปรดติดต่อแจ้งความประสงค์หรือแก้ไขเปลี่ยนความประสงค์ต่อบริษัทฯ ภายในวันทำการสุดท้ายของรอบปีภาษีเพื่อให้มีผลเป็นการเปลี่ยนแปลงความประสงค์ตั้งแต่รอบปีภาษีที่ท่านแจ้งไว้เป็นต้นไป',
    'tax_remark3': '3. ข้าพเจ้ารับทราบว่าบริษัทฯ อาจเปิดเผยข้อมูลการแจ้งความประสงค์ตามแบบแจ้งความประสงค์นี้ให้กับผู้สนับสนุนการขายและรับซื้อคืนหน่วยลงทุนของบริษัทฯ ที่ข้าพเจ้ามีบัญชีหน่วยลงทุนอยู่เพื่อประโยชน์ในการให้บริการและการบริหารจัดการบัญชีหน่วยลงทุนข้าพเจ้า',
    'tax_given': 'ข้าพเจ้า <U>มีความประสงค์</U> ให้บริษัทหลักทรัพย์จัดการกองทุน วรรณ จำกัด นำส่งและเปิดเผยข้อมูลใดๆ ที่เกี่ยวกับการลงทุนในกองทุนรวมเพื่อการออม กองทุนรวมเพื่อการเลี้ยงชีพ หรือกองทุนรวมอื่นใดที่สามารถใช้สิทธิลดหย่อนภาษีได้ตลอดทั้งปีภาษี <b>2565</b> เป็นต้นไป ของข้าพเจ้าต่อกรมสรรพากร เพื่อประโยชน์ในการใช้สิทธิยกเว้นภาษีเงินได้บุคคลธรรมดาของข้าพเจ้า ทั้งนี้ ตามหลักเกณฑ์ เงื่อนไข และวิธีการที่กรมสรรพากรกำหนด',
    'tax_not_given': 'ข้าพเจ้า <U>ไม่มีความประสงค์</U> ให้บริษัทหลักทรัพย์จัดการกองทุน วรรณ จำกัด นำส่งข้อมูลใดๆ ที่เกี่ยวกับการลงทุนในกองทุนรวมที่สามารถใช้สิทธิลดหย่อนภาษีได้ของข้าพเจ้าต่อกรมสรรพากร เพื่อประโยชน์ในการใช้สิทธิยกเว้นภาษีเงินได้บุคคลธรรมดาของข้าพเจ้า ทั้งนี้ ตามหลักเกณฑ์ เงื่อนไข และวิธีการที่กรมสรรพากรกำหนด',
    'tax_not_consent_header': 'แจ้งความประสงค์ในการใช้สิทธิขอยกเว้นภาษีเงินได้',
    'tax_not_consent': 'ท่านรับทราบว่าหากเลือก "ไม่มีความประสงค์" บริษัทฯ จะไม่นำส่งข้อมูลการลงทุนในกองทุนรวมเพื่อการออม กองทุนรวมเพื่อการเลี้ยงชีพ หรือกองทุนรวมที่อาจใช้สิทธิยกเว้นภาษีเงินได้ของท่านส่งให้กรมสรรพากรในรูปแบบอิเล็กทรอนิกส์',
    'tax_not_consent2': 'ท่านจะไม่ได้รับสิทธิยกเว้นภาษีเงินได้ จากการลงทุนในกองทุนรวมเพื่อการออม กองทุนรวมเพื่อการเลี้ยงชีพ หรือกองทุนรวมที่อาจใช้สิทธิยกเว้นภาษีเงินได้',
    'tax_submit_consent': 'บลจ.วรรณ ได้รับแจ้งความประสงค์ใช้สิทธิยกเว้นภาษีเงินได้และให้ความยินยอมนำส่งข้อมูลการการลงทุนในกองทุนรวมเพื่อการออม กองทุนรวมเพื่อการเลี้ยงชีพ หรือกองทุนรวมที่อาจใช้สิทธิยกเว้นภาษีเงินได้ส่งให้กรมสรรพากรของท่านแล้ว หากต้องการเปลี่ยนแปลงสามารถลงทะเบียนอีกครั้ง',
    'tax_submit_no_consent': 'บลจ.วรรณ ได้รับแจ้งว่าท่านไม่มีความประสงค์ใช้สิทธิยกเว้นภาษีเงินได้และไม่ให้ความยินยอมนำส่งข้อมูลการการลงทุนในกองทุนรวมเพื่อการออม กองทุนรวมเพื่อการเลี้ยงชีพ หรือกองทุนรวมที่อาจใช้สิทธิยกเว้นภาษีเงินได้ส่งให้กรมสรรพากร หากต้องการเปลี่ยนแปลงสามารถลงทะเบียนอีกครั้ง',
    'tax_submit': 'ตกลง',
    'tax_confirm': 'ยืนยัน',
    'tax_cancel': 'ยกเลิก',

    'cs_edoc_dropdown1': 'แจ้งความประสงค์ใช้สิทธิยกเว้นภาษีเงินได้',
    'cs_edoc_dropdown2': 'ดาวน์โหลดหนังสือรับรอง',
    'cs_edoc_dropdown3': 'ขอใช้สิทธิเจ้าของข้อมูลส่วนบุคคล',
    'cs_edoc_dropdown4': 'แก้ไขคำยินยอม',
    'cs_edoc_onlyOne': '(เฉพาะบัญชีเปิดผ่านบลจ.วรรณโดยตรง)',
    'cs_edoc_profile': 'ข้อมูลผู้ลงทุน',

    // e-document
    'ed_edoc101': 'หนังสือรับรองการซื้อหน่วยลงทุน',
    'ed_edoc101_1': 'แสดงหนังสือรับรองหน่วยลงทุนย้อนหลังสูงสุด 5 ปี',
    'ed_edoc101_1_remark': '(หมายเหตุ: ออกรายงานปีล่าสุดได้ตั้งแต่วันที่ 16 มกราคม)',
    'ed_edoc101_download': 'ดาวน์โหลดหนังสือรับรองการซื้อหน่วยลงทุน',
    'ed_edoc102': 'หนังสือรับรองการขายหน่วยลงทุน',
    'ed_edoc102_1': 'แสดงหนังสือรับรองหน่วยลงทุนตั้งแต่วันที่ 1 มกราคม ของปีก่อนหน้า ถึงปัจจุบัน',
    'ed_edoc102_download': 'ดาวน์โหลดหนังสือรับรองการขายหน่วยลงทุน',
    'ed_edoc103': 'หนังสือรับรองการโอนหน่วยลงทุน',
    'ed_edoc103_download': 'ดาวน์โหลดหนังสือรับรองการโอนหน่วยลงทุน',
    'ed_edoc104': 'หนังสือรับรองสิทธิในหน่วยลงทุน',
    'ed_edoc104_1': 'แสดงรายงานย้อนหลังสูงสุด 3 เดือน',
    'ed_edoc104_download': 'ดาวน์โหลดหนังสือรับรองสิทธิในหน่วยลงทุน',
    'ed_edoc105': 'รายงานการถือหน่วยลงทุน',
    'ed_edoc105_1': 'แสดงรายงานย้อนหลัง 1 ปี',
    'ed_edoc105_download': 'ดาวน์โหลดรายงานการถือหน่วยลงทุน',

    'ed_holderno': 'เลขที่ผู้ถือหน่วย',
    'ed_fund_code': 'กองทุน',
    'ed_select_all': 'แสดงทั้งหมด',
    'ed_year': 'ปี',
    'ed_month': 'เดือน',
    'ed_logout': 'ออกจากระบบ',
    'ed_login': 'กรุณากรอกเลขบัตรประจำตัวประชาชนหรือเลขหนังสือเดินทางเพื่อเข้าสู่ระบบ',
    'ed_customer': 'ลูกค้า',

    'ed_login_error_405': 'ไม่พบเลขบัตรประชาชน หรือ Passport นี้ในระบบ กรุณาติดต่อเจ้าหน้าที่',
    'ed_login_error_404': 'ไม่พบข้อมูลลูกค้า',
    'ed_login_error_403': 'กรุณารอ 3 นาที ก่อนขอ OTP อีกครั้ง',
    'ed_login_error_402': 'ไม่พบหมายเลขโทรศัพท์มือถือที่จะรับ OTP กรุณาติดต่อหน่วยงานลูกค้าสัมพันธ์ โทร. 02-659-8888 กด 1',

    'ed_loging_error_401': 'กรุณาติดต่อหน่วยงานลูกค้าสัมพันธ์ โทร. 02-659-8888 กด 1',

    'ed_otp_error_101': 'ข้อมูลไม่ครบ กรุณาลองใหม่อีกครั้ง',
    'ed_otp_error_102': 'รหัส OTP ไม่ถูกต้อง',
    'ed_for_foreigner': 'ลูกค้าไม่สามารถ Apply for income tax exemption ได้เนื่องจากสรรพกรไม่รับ Passport number กรุณาติดต่อหน่วยงานลูกค้าสัมพันธ์ โทร. 02-659-8888 กด 1',
    'ed_pop_up': 'ปิด',


    //index level ktb

    'idl_header': 'INDEX LEVEL',
    'idl_sub_header': 'J.P. Morgan Mozaic XRP Index Linked Fund',
    'idl_dis_0': 'The information on this page, including the index levels for the J.P. Morgan Mozaic XRP Index (J.P. Morgan 4% Vol Target Mozaic XRP 1% Decrement Index (JMAB392E)) (“Index”), is presented by One Asset Management Limited (“ONEAM”) in relation to the ONE COMPLEX RETURN FUND NOT FOR RETAIL INVESTORS (ONE-COMPLEXRETURN) (the “Non-JPM Product”). Such information does not comprise, and may differ from, the official index levels of the Index that is published by the index calculation agent of the Index, and J.P. Morgan Securities plc (“JPMS plc”) or any of its affiliates (together and individually, “JPMorgan”) has no responsibility or liability for any loss or damage arising from any reliance on or use of such information in any way. The Index has been sub-licensed to ONEAM (the “Sub-Licensee”) for the Sub-Licensee’s benefit. Neither the Sub-Licensee nor the Non-JPM Product is sponsored, operated, endorsed, recommended, sold or promoted by JPMorgan. JPMorgan makes no representation and gives no warranty, express or implied, to investors in or those otherwise taking exposure to the Non-JPM Product. Such persons should seek appropriate professional advice before making any investment. The Index has been designed and is compiled, calculated, maintained and sponsored by JPMS plc without regard to the Sub-Licensee, the Non-JPM Product or any investor. JPMS plc is under no obligation to continue compiling, calculating, maintaining or sponsoring the Index. JPMorgan may independently issue or sponsor other indices or products that are similar to and may compete with the Index and the Non-JPM Product. They may also transact in assets referenced in the Index (or in financial instruments such as derivatives that reference those assets). These activities could have a positive or negative effect on the value of the Index and the Non-JPM Product.',
    'idl_dis': 'หมายเหตุ : ข้อมูลระดับดัชนี J.P. Morgan Mozaic XRP Index (J.P. Morgan 4% Vol Target Mozaic XRP 1% Decrement Index (JMAB392E)) ที่แสดงนี้ จัดทำโดยผู้จัดทำดัชนี (Index Provider) โดย บลจ.วรรณ มีวัตถุประสงค์เพื่อให้ผู้ถือหน่วยลงทุนที่ลงทุนในกองทุนเปิด วรรณ คอมเพล็กซ์ รีเทิร์น ห้ามขายผู้ลงทุนรายย่อย (ONE-COMPLEXRETURN) สามารถติดตามข้อมูลของดัชนี J.P. Morgan Mozaic XRP Index (J.P. Morgan 4% Vol Target Mozaic XRP 1% Decrement Index (JMAB392E)) ที่ใช้เป็นดัชนีอ้างอิงตามนโยบายการลงทุนของกองทุนดังกล่าวเท่านั้น ห้ามมิให้นำข้อมูลนี้ไปใช้อ้างอิงเพื่อวัตถุประสงค์อื่นใดหรือเพื่อประกอบการทำธุรกรรมอื่นใดนอกเหนือจากวัตถุประสงค์ที่ได้ระบุไว้ข้างต้น ทั้งนี้ บลจ.วรรณ เป็นเพียงผู้เผยแพร่ข้อมูลเพื่อความสะดวกเท่านั้น ดังนั้น บริษัทจัดการจึงไม่มีอำนาจควบคุม รับรอง หรือยืนยันความถูกต้องของดัชนี และ/หรือ ข้อมูลใดๆ ที่เกี่ยวกับดัชนี และไม่รับผิดชอบต่อความเสียหายไม่ว่าทางตรง ทางอ้อม หรือที่เป็นผลเกี่ยวเนื่องจากการใช้ดัชนีดังกล่าวซึ่งเกิดขึ้นต่อบุคคลใดไม่ว่ากรณีใดๆ',
    'btn_idl':'ข้อมูล Index Level',

    // asset profile
    'ap_could_not_fine':'ไม่พบข้อมูล',
    'ap_HNW':'คุณสมบัติด้านสินทรัพย์ผู้ลงทุนรายใหญ่ (HNW)',
    'ap_UHNW':'คุณสมบัติด้านสินทรัพย์ผู้ลงทุนรายใหญ่พิเศษ (UHNW)',
    'ap_Angel':'คุณสมบัติด้านสินทรัพย์ผู้ลงทุนสถาบันเฉพาะ',
    'ap_btn_Add':"เพิ่มข้อมูล",
    'ap_btn_Edit':"แก้ไขข้อมูล",
    'ap_btn_Preview':'แสดงข้อมูล',
    'ap_is_Pass':"ผ่านการพิจารณา",
    'ap_is_NotPass':"ไม่ผ่านการพิจารณา",
    'ap_Assessmnet_date':"วันที่ประเมิน",
    'ap_Due_date':"วันครบกำหนด",
    'ap_Status':"สถานะ",
    'ap_Head_HNW_UHNW':'ข้อมูลคุณสมบัติด้านสินทรัพย์ผู้ลงทุนรายใหญ่ หรือรายใหญ่พิเศษ',
    'ap_Head_Angel':'ข้อมูลคุณสมบัติด้านสินทรัพย์ผู้ลงทุนสถาบันเฉพาะ',
    'ap_btn_save':'บันทึก',
    'ap_btn_back':'ย้อนกลับ',
    'ap_popup_confirm':'ยืนยันการทำแบบประเมิน',
    'ap_head':'แบบประเมินคุณสมบัติด้านสินทรัพย์สำหรับผู้ลงทุน',

}
